// 3.11.4

export { Tween, Circ };

let _config = {
    autoSleep: 120,
    force3D: 'auto',
    nullTargetWarn: 1,
    units: { lineHeight: '' },
  },
  _defaults: any = {
    duration: .5,
    overwrite: false,
    delay: 0,
  },
  _suppressOverwrites: any,
  _reverting: any,
  _context: any,
  _bigNum = 1e8,
  _tinyNum = 1 / _bigNum,
  _2PI = Math.PI * 2,
  _HALF_PI = _2PI / 4,
  _gsID = 0,
  _sqrt = Math.sqrt,
  _cos = Math.cos,
  _sin = Math.sin,
  _isString = (value: any) => typeof (value) === 'string',
  _isFunction = (value: any) => typeof (value) === 'function',
  _isNumber = (value: any) => typeof (value) === 'number',
  _isUndefined = (value: any) => typeof (value) === 'undefined',
  _isObject = (value: any) => typeof (value) === 'object',
  _isNotFalse = (value: any) => value !== false,
  _windowExists = () => typeof (window) !== 'undefined',
  // _isFuncOrString = (value: any) => _isFunction(value) || _isString(value),
  _isTypedArray = (typeof ArrayBuffer === 'function' && ArrayBuffer.isView) || function() {
  }, // note: IE10 has ArrayBuffer, but NOT ArrayBuffer.isView().
  _isArray = Array.isArray,
  _strictNumExp = /(?:-?\.?\d|\.)+/gi, //only numbers (including negatives and decimals) but NOT relative values.
  // _numExp = /[-+=.]*\d+[.e\-+]*\d*[e\-+]*\d*/g, //finds any numbers, including ones that start with += or -=, negative numbers, and ones in scientific notation like 1e-8.
  // _numWithUnitExp = /[-+=.]*\d+[.e-]*\d*[a-z%]*/g,
  _complexStringNumExp = /[-+=.]*\d+\.?\d*(?:e-|e\+)?\d*/gi, //duplicate so that while we're looping through matches from exec(), it doesn't contaminate the lastIndex of _numExp which we use to search for colors too.
  _relExp = /[+-]=-?[.\d]+/,
  _delimitedValueExp = /[^,'"\[\]\s]+/gi, // previously /[#\-+.]*\b[a-z\d\-=+%.]+/gi but didn't catch special characters.
  _unitExp = /^[+\-=e\s\d]*\d+[.\d]*([a-z]*|%)\s*$/i,
  _globalTimeline: any,
  _win: any,
  _coreInitted: any,
  _doc: any,
  _globals: any = {},
  _installScope: any = {},
  _coreReady: any,
  _install = (scope: any) => (_installScope = _merge(scope, _globals)) && gsap,
  _missingPlugin = (property: any, value: any) => console.warn('Invalid property', property, 'set to', value, 'Missing plugin? registerPlugin()'),
  // _warn = (message: any, suppress?: any) => !suppress && console.warn(message),
  _addGlobal = (name: any, obj: any) => (name && (_globals[name] = obj) && (_installScope && (_installScope[name] = obj))) || _globals,
  _emptyFunc = () => 0,
  _startAtRevertConfig = { suppressEvents: true, isStart: true, kill: false },
  _revertConfigNoKill = { suppressEvents: true, kill: false },
  // _revertConfig = { suppressEvents: true },
  _reservedProps: any = {},
  _lazyTweens: any[] = [],
  _lazyLookup: any = {},
  _lastRenderedFrame: any,
  _plugins: any = {},
  _effects = {},
  _nextGCFrame = 30,
  _harnessPlugins: any[] = [],
  _callbackNames = '',

  _harness = (targets: any) => {
    let target = targets[0], harnessPlugin, i;
    _isObject(target) || _isFunction(target) || (targets = [targets]);

    if (!(harnessPlugin = (target._gsap || {}).harness)) { // find the first target with a harness. We assume targets passed into an animation will be of similar type, meaning the same kind of harness can be used for them all (performance optimization)
      i = _harnessPlugins.length;
      while (i-- && !_harnessPlugins[i].targetTest(target)) {
      }
      harnessPlugin = _harnessPlugins[i];
    }

    i = targets.length;

    while (i--) {
      (targets[i] && (targets[i]._gsap || (targets[i]._gsap = new GSCache(targets[i], harnessPlugin)))) || targets.splice(i, 1);
    }

    return targets;
  },

  _getCache = (target: any) => target._gsap || _harness(toArray(target))[0]._gsap,
  _getProperty = (target: any, property: any, v: any) => (v = target[property]) && _isFunction(v) ? target[property]() : (_isUndefined(v) && target.getAttribute && target.getAttribute(property)) || v,
  _forEachName = (names: any, func: any) => ((names = names.split(',')).forEach(func)) || names, //split a comma-delimited list of names into an array, then run a forEach() function and return the split array (this is just a way to consolidate/shorten some code).
  // _round = value => Math.round(value * 100000) / 100000 || 0,
  _roundPrecise = (value: any) => Math.round(value * 10000000) / 10000000 || 0, // increased precision mostly for timing values.

  _parseRelative = (start: any, value: any) => {
    let operator = value.charAt(0), end = parseFloat(value.substr(2));
    start = parseFloat(start);

    return operator === '+' ? start + end : operator === '-' ? start - end : operator === '*' ? start * end : start / end;
  },

  _arrayContainsAny = (toSearch: any, toFind: any) => { //searches one array to find matches for any of the items in the toFind array. As soon as one is found, it returns true. It does NOT return all the matches; it's simply a boolean search.
    let l = toFind.length, i = 0;

    for (; toSearch.indexOf(toFind[i]) < 0 && ++i < l;) {
    }

    return (i < l);
  },

  _lazyRender = () => {
    let l = _lazyTweens.length, a = _lazyTweens.slice(0), i, tween;
    _lazyLookup = {};
    _lazyTweens.length = 0;

    for (i = 0; i < l; i++) {
      tween = a[i];
      tween && tween._lazy && (tween.render(tween._lazy[0], tween._lazy[1], true)._lazy = 0);
    }
  },

  _lazySafeRender = (animation: any, time: any, suppressEvents?: any, force?: any): void => {
    _lazyTweens.length && !_reverting && _lazyRender();
    animation.render(time, suppressEvents, force || (_reverting && time < 0 && (animation._initted || animation._startAt)));
    _lazyTweens.length && !_reverting && _lazyRender(); //in case rendering caused any tweens to lazy-init, we should render them because typically when someone calls seek() or time() or progress(), they expect an immediate render.
  },

  _numericIfPossible = (value: any) => {
    let n = parseFloat(value);
    return (n || n === 0) && (value + '').match(_delimitedValueExp)!.length < 2 ? n : _isString(value) ? value.trim() : value;
  },

  // _passThrough = (p: any) => p,

  _setDefaults = (obj: any, defaults: any) => {
    for (let p in defaults) {
      (p in obj) || (obj[p] = defaults[p]);
    }

    return obj;
  },

  _setKeyframeDefaults = (excludeDuration: any) => (obj: any, defaults: any) => {
    for (let p in defaults) {
      (p in obj) || (p === 'duration' && excludeDuration) || p === 'ease' || (obj[p] = defaults[p]);
    }
  },

  _merge = (base: any, toMerge: any) => {
    for (let p in toMerge) {
      base[p] = toMerge[p];
    }

    return base;
  },

  _copyExcluding = (obj: any, excluding: any) => {
    let copy: any = {}, p;

    for (p in obj) {
      (p in excluding) || (copy[p] = obj[p]);
    }

    return copy;
  },

  _inheritDefaults = (vars: any) => {
    let parent = vars.parent || _globalTimeline,
      func = vars.keyframes ? _setKeyframeDefaults(_isArray(vars.keyframes)) : _setDefaults;

    if (_isNotFalse(vars.inherit)) {
      while (parent) {
        func(vars, parent.vars.defaults);
        parent = parent.parent || parent._dp;
      }
    }

    return vars;
  },

  // _arraysMatch = (a1: any, a2: any) => {
  //   let i = a1.length, match = i === a2.length;
  //
  //   while (match && i-- && a1[i] === a2[i]) {
  //   }
  //
  //   return i < 0;
  // },

  _addLinkedListItem = (parent: any, child: any, firstProp = '_first', lastProp = '_last', sortBy: any) => {
    let prev = parent[lastProp], t;

    if (sortBy) {
      t = child[sortBy];
      while (prev && prev[sortBy] > t) {
        prev = prev._prev;
      }
    }

    if (prev) {
      child._next = prev._next;
      prev._next = child;
    } else {
      child._next = parent[firstProp];
      parent[firstProp] = child;
    }

    if (child._next) {
      child._next._prev = child;
    } else {
      parent[lastProp] = child;
    }

    child._prev = prev;
    child.parent = child._dp = parent;

    return child;
  },

  _removeLinkedListItem = (parent: any, child: any, firstProp = '_first', lastProp = '_last') => {
    let prev = child._prev, next = child._next;

    if (prev) {
      prev._next = next;
    } else if (parent[firstProp] === child) {
      parent[firstProp] = next;
    }

    if (next) {
      next._prev = prev;
    } else if (parent[lastProp] === child) {
      parent[lastProp] = prev;
    }

    child._next = child._prev = child.parent = null; // don't delete the _dp just so we can revert if necessary. But parent should be null to indicate the item isn't in a linked list.
  },

  _removeFromParent = (child: any, onlyIfParentHasAutoRemove?: any) => {
    child.parent && (!onlyIfParentHasAutoRemove || child.parent.autoRemoveChildren) && child.parent.remove(child);
    child._act = 0;
  },

  _uncache = (animation: any, child?: any) => {
    if (animation && (!child || child._end > animation._dur || child._start < 0)) { // performance optimization: if a child animation is passed in we should only uncache if that child EXTENDS the animation (its end time is beyond the end)
      let a = animation;

      while (a) {
        a._dirty = 1;
        a = a.parent;
      }
    }

    return animation;
  },

  _recacheAncestors = (animation: any) => {
    let parent = animation.parent;

    while (parent && parent.parent) { //sometimes we must force a re-sort of all children and update the duration/totalDuration of all ancestor timelines immediately in case, for example, in the middle of a render loop, one tween alters another tween's timeScale which shoves its startTime before 0, forcing the parent timeline to shift around and shiftChildren() which could affect that next tween's render (startTime). Doesn't matter for the root timeline though.
      parent._dirty = 1;
      parent.totalDuration();
      parent = parent.parent;
    }

    return animation;
  },

  _rewindStartAt = (tween: any, totalTime: any, force: any) => tween._startAt && (_reverting ? tween._startAt.revert(_revertConfigNoKill) : (tween.vars.immediateRender && !tween.vars.autoRevert) || tween._startAt.render(totalTime, true, force)),
  _hasNoPausedAncestors: any = (animation: any): any => !animation || (animation._ts && _hasNoPausedAncestors(animation.parent)),
  // _elapsedCycleDuration = (animation: any) => animation._repeat ? _animationCycle(animation._tTime, (animation = animation.duration() + animation._rDelay)) * animation : 0,
  // feed in the totalTime and cycleDuration and it'll return the cycle (iteration minus 1) and if the playhead is exactly at the very END, it will NOT bump up to the next cycle.

  _animationCycle = (tTime: any, cycleDuration: any) => {
    let whole = Math.floor(tTime /= cycleDuration);

    return tTime && (whole === tTime) ? whole - 1 : whole;
  },

  _parentToChildTotalTime = (parentTime: any, child: any) => (parentTime - child._start) * child._ts + (child._ts >= 0 ? 0 : (child._dirty ? child.totalDuration() : child._tDur)),
  _setEnd = (animation: any) => (animation._end = _roundPrecise(animation._start + ((animation._tDur / Math.abs(animation._ts || animation._rts || _tinyNum)) || 0))),

  _alignPlayhead = (animation: any, totalTime: any) => { // adjusts the animation's _start and _end according to the provided totalTime (only if the parent's smoothChildTiming is true and the animation isn't paused). It doesn't do any rendering or forcing things back into parent timelines, etc. - that's what totalTime() is for.
    let parent = animation._dp;

    if (parent && parent.smoothChildTiming && animation._ts) {
      animation._start = _roundPrecise(parent._time - (animation._ts > 0 ? totalTime / animation._ts : ((animation._dirty ? animation.totalDuration() : animation._tDur) - totalTime) / -animation._ts));
      _setEnd(animation);
      parent._dirty || _uncache(parent, animation); //for performance improvement. If the parent's cache is already dirty, it already took care of marking the ancestors as dirty too, so skip the function call here.
    }

    return animation;
  },

  _postAddChecks = (timeline: any, child: any) => {
    let t;

    if (child._time || (child._initted && !child._dur)) { //in case, for example, the _start is moved on a tween that has already rendered. Imagine it's at its end state, then the startTime is moved WAY later (after the end of this timeline), it should render at its beginning.
      t = _parentToChildTotalTime(timeline.rawTime(), child);
      if (!child._dur || _clamp(0, child.totalDuration(), t) - child._tTime > _tinyNum) {
        child.render(t, true);
      }
    }

    //if the timeline has already ended but the inserted tween/timeline extends the duration, we should enable this timeline again so that it renders properly. We should also align the playhead with the parent timeline's when appropriate.
    if (_uncache(timeline, child)._dp && timeline._initted && timeline._time >= timeline._dur && timeline._ts) {
      //in case any of the ancestors had completed but should now be enabled...
      if (timeline._dur < timeline.duration()) {
        t = timeline;

        while (t._dp) {
          (t.rawTime() >= 0) && t.totalTime(t._tTime); //moves the timeline (shifts its startTime) if necessary, and also enables it. If it's currently zero, though, it may not be scheduled to render until later so there's no need to force it to align with the current playhead position. Only move to catch up with the playhead.
          t = t._dp;
        }
      }

      timeline._zTime = -_tinyNum; // helps ensure that the next render() will be forced (crossingStart = true in render()), even if the duration hasn't changed (we're adding a child which would need to get rendered). Definitely an edge case. Note: we MUST do this AFTER the loop above where the totalTime() might trigger a render() because this _addToTimeline() method gets called from the Animation constructor, BEFORE tweens even record their targets, etc. so we wouldn't want things to get triggered in the wrong order.
    }
  },
  _addToTimeline = (timeline: any, child: any, position: any, skipChecks?: any) => {
    child.parent && _removeFromParent(child);
    child._start = _roundPrecise((_isNumber(position) ? position : position || timeline !== _globalTimeline ? _parsePosition(timeline, position, child) : timeline._time) + child._delay);
    child._end = _roundPrecise(child._start + ((child.totalDuration() / Math.abs(child.timeScale())) || 0));
    _addLinkedListItem(timeline, child, '_first', '_last', timeline._sort ? '_start' : 0);
    _isFromOrFromStart(child) || (timeline._recent = child);
    skipChecks || _postAddChecks(timeline, child);
    timeline._ts < 0 && _alignPlayhead(timeline, timeline._tTime); // if the timeline is reversed and the new child makes it longer, we may need to adjust the parent's _start (push it back)

    return timeline;
  },

  _scrollTrigger = (animation: any, trigger: any) => (_globals.ScrollTrigger || _missingPlugin('scrollTrigger', trigger)) && _globals.ScrollTrigger.create(trigger, animation),
  _attemptInitTween: any = (tween: any, time: any, force: any, suppressEvents: any, tTime: any): any => {
    _initTween(tween, time, tTime);

    if (!tween._initted) {
      return 1;
    }

    if (!force && tween._pt && !_reverting && ((tween._dur && tween.vars.lazy !== false) || (!tween._dur && tween.vars.lazy)) && _lastRenderedFrame !== _ticker.frame) {
      _lazyTweens.push(tween);
      tween._lazy = [tTime, suppressEvents];

      return 1;
    }
  },

  _parentPlayheadIsBeforeStart: any = ({ parent }: any) => parent && parent._ts && parent._initted && !parent._lock && (parent.rawTime() < 0 || _parentPlayheadIsBeforeStart(parent)), // check parent's _lock because when a timeline repeats/yoyos and does its artificial wrapping, we shouldn't force the ratio back to 0
  _isFromOrFromStart = ({ data }: any) => data === 'isFromStart' || data === 'isStart',
  _renderZeroDurationTween = (tween: any, totalTime: any, suppressEvents: any, force: any) => {
    let prevRatio = tween.ratio,
      ratio = totalTime < 0 || (!totalTime && ((!tween._start && _parentPlayheadIsBeforeStart(tween) && !(!tween._initted && _isFromOrFromStart(tween))) || ((tween._ts < 0 || tween._dp._ts < 0) && !_isFromOrFromStart(tween)))) ? 0 : 1, // if the tween or its parent is reversed and the totalTime is 0, we should go to a ratio of 0. Edge case: if a from() or fromTo() stagger tween is placed later in a timeline, the "startAt" zero-duration tween could initially render at a time when the parent timeline's playhead is technically BEFORE where this tween is, so make sure that any "from" and "fromTo" startAt tweens are rendered the first time at a ratio of 1.
      repeatDelay = tween._rDelay,
      tTime = 0,
      pt, iteration, prevIteration;

    if (repeatDelay && tween._repeat) { // in case there's a zero-duration tween that has a repeat with a repeatDelay
      tTime = _clamp(0, tween._tDur, totalTime);
      iteration = _animationCycle(tTime, repeatDelay);
      tween._yoyo && (iteration & 1) && (ratio = 1 - ratio);

      if (iteration !== _animationCycle(tween._tTime, repeatDelay)) { // if iteration changed
        prevRatio = 1 - ratio;
        tween.vars.repeatRefresh && tween._initted && tween.invalidate();
      }
    }

    if (ratio !== prevRatio || _reverting || force || tween._zTime === _tinyNum || (!totalTime && tween._zTime)) {
      if (!tween._initted && _attemptInitTween(tween, totalTime, force, suppressEvents, tTime)) { // if we render the very beginning (time == 0) of a fromTo(), we must force the render (normal tweens wouldn't need to render at a time of 0 when the prevTime was also 0). This is also mandatory to make sure overwriting kicks in immediately.
        return;
      }

      prevIteration = tween._zTime;
      tween._zTime = totalTime || (suppressEvents ? _tinyNum : 0); // when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect.
      suppressEvents || (suppressEvents = totalTime && !prevIteration); // if it was rendered previously at exactly 0 (_zTime) and now the playhead is moving away, DON'T fire callbacks otherwise they'll seem like duplicates.
      tween.ratio = ratio;
      tween._from && (ratio = 1 - ratio);
      tween._time = 0;
      tween._tTime = tTime;
      pt = tween._pt;

      while (pt) {
        pt.r(ratio, pt.d);
        pt = pt._next;
      }

      totalTime < 0 && _rewindStartAt(tween, totalTime, true);
      tween._onUpdate && !suppressEvents && _callback(tween, 'onUpdate');
      tTime && tween._repeat && !suppressEvents && tween.parent && _callback(tween, 'onRepeat');

      if ((totalTime >= tween._tDur || totalTime < 0) && tween.ratio === ratio) {
        ratio && _removeFromParent(tween, 1);

        if (!suppressEvents && !_reverting) {
          _callback(tween, (ratio ? 'onComplete' : 'onReverseComplete'), true);
          tween._prom && tween._prom();
        }
      }
    } else if (!tween._zTime) {
      tween._zTime = totalTime;
    }
  },

  _findNextPauseTween = (animation: any, prevTime: any, time: any) => {
    let child;

    if (time > prevTime) {
      child = animation._first;

      while (child && child._start <= time) {
        if (child.data === 'isPause' && child._start > prevTime) {
          return child;
        }

        child = child._next;
      }
    } else {
      child = animation._last;

      while (child && child._start >= time) {
        if (child.data === 'isPause' && child._start < prevTime) {
          return child;
        }

        child = child._prev;
      }
    }
  },

  _setDuration = (animation: any, duration: any, skipUncache?: any, leavePlayhead?: any) => {
    let repeat = animation._repeat, dur = _roundPrecise(duration) || 0,
      totalProgress = animation._tTime / animation._tDur;
    totalProgress && !leavePlayhead && (animation._time *= dur / animation._dur);
    animation._dur = dur;
    animation._tDur = !repeat ? dur : repeat < 0 ? 1e10 : _roundPrecise(dur * (repeat + 1) + (animation._rDelay * repeat));
    totalProgress > 0 && !leavePlayhead && _alignPlayhead(animation, (animation._tTime = animation._tDur * totalProgress));
    animation.parent && _setEnd(animation);
    skipUncache || _uncache(animation.parent, animation);

    return animation;
  },

  // _onUpdateTotalDuration = (animation: any) => (animation instanceof Timeline) ? _uncache(animation) : _setDuration(animation, animation._dur),
  _zeroPosition = { _start: 0, endTime: _emptyFunc, totalDuration: _emptyFunc },

  _parsePosition: any = (animation: any, position: any, percentAnimation: any): any => {
    let labels = animation.labels,
      recent = animation._recent || _zeroPosition,
      clippedDuration = animation.duration() >= _bigNum ? recent.endTime(false) : animation._dur, //in case there's a child that infinitely repeats, users almost never intend for the insertion point of a new child to be based on a SUPER long value like that so we clip it and assume the most recently-added child's endTime should be used instead.
      i, offset, isPercent;

    if (_isString(position) && (isNaN(position) || (position in labels))) { //if the string is a number like "1", check to see if there's a label with that name, otherwise interpret it as a number (absolute value).
      offset = position.charAt(0);
      isPercent = position.substr(-1) === '%';
      i = position.indexOf('=');

      if (offset === '<' || offset === '>') {
        i >= 0 && (position = position.replace(/=/, ''));

        return (offset === '<' ? recent._start : recent.endTime(recent._repeat >= 0)) + (parseFloat(position.substring(1)) || 0) * (isPercent ? (i < 0 ? recent : percentAnimation).totalDuration() / 100 : 1);
      }

      if (i < 0) {
        (position in labels) || (labels[position] = clippedDuration);

        return labels[position];
      }

      offset = parseFloat(position.charAt(i - 1) + position.substring(i + 1));

      if (isPercent && percentAnimation) {
        offset = offset / 100 * (_isArray(percentAnimation) ? percentAnimation[0] : percentAnimation).totalDuration();
      }

      return (i > 1) ? _parsePosition(animation, position.substring(0, i - 1), percentAnimation) + offset : clippedDuration + offset;
    }

    return (position == null) ? clippedDuration : +position;
  },

  // _createTweenType = (type: any, params: any, timeline: any) => {
  //   let isLegacy = _isNumber(params[1]),
  //     varsIndex = (isLegacy ? 2 : 1) + (type < 2 ? 0 : 1),
  //     vars = params[varsIndex],
  //     irVars, parent;
  //   isLegacy && (vars.duration = params[1]);
  //   vars.parent = timeline;
  //
  //   if (type) {
  //     irVars = vars;
  //     parent = timeline;
  //
  //     while (parent && !('immediateRender' in irVars)) { // inheritance hasn't happened yet, but someone may have set a default in an ancestor timeline. We could do vars.immediateRender = _isNotFalse(_inheritDefaults(vars).immediateRender) but that'd exact a slight performance penalty because _inheritDefaults() also runs in the Tween constructor. We're paying a small kb price here to gain speed.
  //       irVars = parent.vars.defaults || {};
  //       parent = _isNotFalse(parent.vars.inherit) && parent.parent;
  //     }
  //
  //     vars.immediateRender = _isNotFalse(irVars.immediateRender);
  //     type < 2 ? (vars.runBackwards = 1) : (vars.startAt = params[varsIndex - 1]); // "from" vars
  //   }
  //
  //   return new Tween(params[0], vars, params[varsIndex + 1]);
  // },

  _conditionalReturn = (value: any, func: any) => value || value === 0 ? func(value) : func,
  _clamp = (min: any, max: any, value: any) => value < min ? min : value > max ? max : value,
  getUnit = (value: any, v?: any) => !_isString(value) || !(v = _unitExp.exec(value)) ? '' : v[1], // note: protect against padded numbers as strings, like "100.100". That shouldn't return "00" as the unit. If it's numeric, return no unit.
  // clamp = (min: any, max: any, value: any) => _conditionalReturn(value, (v: any) => _clamp(min, max, v)),
  _slice = [].slice,
  _isArrayLike = (value: any, nonEmpty?: any) => value && (_isObject(value) && 'length' in value && ((!nonEmpty && !value.length) || ((value.length - 1) in value && _isObject(value[0]))) && !value.nodeType && value !== _win),
  _flatten = (ar: any, leaveStrings: any, accumulator = []) => ar.forEach((value: never) => (_isString(value) && !leaveStrings) || _isArrayLike(value, 1) ? accumulator.push(value) : accumulator.push(value)) || accumulator,
  //takes any value and returns an array. If it's a string (and leaveStrings isn't true), it'll use document.querySelectorAll() and convert that to an array. It'll also accept iterables like jQuery objects.
  toArray = (value: any, scope?: any, leaveStrings?: any) => _context && !scope && _context.selector ? _context.selector(value) : _isString(value) && !leaveStrings && (_coreInitted || !_wake()) ? _slice.call((scope || _doc).querySelectorAll(value), 0) : _isArray(value) ? _flatten(value, leaveStrings) : _isArrayLike(value) ? _slice.call(value, 0) : value ? [value] : [],

  // selector = (value: any) => {
  //   value = toArray(value)[0] || _warn('Invalid scope') || {};
  //
  //   return (v: any) => {
  //     let el = value.current || value.nativeElement || value;
  //
  //     return toArray(v, el.querySelectorAll ? el : el === value ? _warn('Invalid scope') || _doc.createElement('div') : value);
  //   };
  // },
  // shuffle = a => a.sort(() => .5 - Math.random()), // alternative that's a bit faster and more reliably diverse but bigger:   for (let j, v, i = a.length; i; j = Math.floor(Math.random() * i), v = a[--i], a[i] = a[j], a[j] = v); return a;
  //for distributing values across an array. Can accept a number, a function or (most commonly) a function which can contain the following properties: {base, amount, from, ease, grid, axis, length, each}. Returns a function that expects the following parameters: index, target, array. Recognizes the following
  // distribute = v => {
  //   if (_isFunction(v)) {
  //     return v;
  //   }
  //   let vars = _isObject(v) ? v : { each: v }, //n:1 is just to indicate v was a number; we leverage that later to set v according to the length we get. If a number is passed in, we treat it like the old stagger value where 0.1, for example, would mean that things would be distributed with 0.1 between each element in the array rather than a total "amount" that's chunked out among them all.
  //     ease = _parseEase(vars.ease),
  //     from = vars.from || 0,
  //     base = parseFloat(vars.base) || 0,
  //     cache = {},
  //     isDecimal = (from > 0 && from < 1),
  //     ratios = isNaN(from) || isDecimal,
  //     axis = vars.axis,
  //     ratioX = from,
  //     ratioY = from;
  //   if (_isString(from)) {
  //     ratioX = ratioY = { center: .5, edges: .5, end: 1 }[from] || 0;
  //   } else if (!isDecimal && ratios) {
  //     ratioX = from[0];
  //     ratioY = from[1];
  //   }
  //   return (i, target, a) => {
  //     let l = (a || vars).length,
  //       distances = cache[l],
  //       originX, originY, x, y, d, j, max, min, wrapAt;
  //     if (!distances) {
  //       wrapAt = (vars.grid === 'auto') ? 0 : (vars.grid || [1, _bigNum])[1];
  //       if (!wrapAt) {
  //         max = -_bigNum;
  //         while (max < (max = a[wrapAt++].getBoundingClientRect().left) && wrapAt < l) {
  //         }
  //         wrapAt--;
  //       }
  //       distances = cache[l] = [];
  //       originX = ratios ? (Math.min(wrapAt, l) * ratioX) - .5 : from % wrapAt;
  //       originY = wrapAt === _bigNum ? 0 : ratios ? l * ratioY / wrapAt - .5 : (from / wrapAt) | 0;
  //       max = 0;
  //       min = _bigNum;
  //       for (j = 0; j < l; j++) {
  //         x = (j % wrapAt) - originX;
  //         y = originY - ((j / wrapAt) | 0);
  //         distances[j] = d = !axis ? _sqrt(x * x + y * y) : Math.abs((axis === 'y') ? y : x);
  //         (d > max) && (max = d);
  //         (d < min) && (min = d);
  //       }
  //       (from === 'random') && shuffle(distances);
  //       distances.max = max - min;
  //       distances.min = min;
  //       distances.v = l = (parseFloat(vars.amount) || (parseFloat(vars.each) * (wrapAt > l ? l - 1 : !axis ? Math.max(wrapAt, l / wrapAt) : axis === 'y' ? l / wrapAt : wrapAt)) || 0) * (from === 'edges' ? -1 : 1);
  //       distances.b = (l < 0) ? base - l : base;
  //       distances.u = getUnit(vars.amount || vars.each) || 0; //unit
  //       ease = (ease && l < 0) ? _invertEase(ease) : ease;
  //     }
  //     l = ((distances[i] - distances.min) / distances.max) || 0;
  //     return _roundPrecise(distances.b + (ease ? ease(l) : l) * distances.v) + distances.u; //round in order to work around floating point errors
  //   };
  // },

  // _roundModifier = (v: any) => { //pass in 0.1 get a function that'll round to the nearest tenth, or 5 to round to the closest 5, or 0.001 to the closest 1000th, etc.
  //   let p = Math.pow(10, ((v + '').split('.')[1] || '').length); //to avoid floating point math errors (like 24 * 0.1 == 2.4000000000000004), we chop off at a specific number of decimal places (much faster than toFixed())
  //
  //   return (raw: any) => {
  //     let n = _roundPrecise(Math.round(parseFloat(raw) / v) * v * p);
  //
  //     return (n - n % 1) / p + (_isNumber(raw) ? 0 : getUnit(raw)); // n - n % 1 replaces Math.floor() in order to handle negative values properly. For example, Math.floor(-150.00000000000003) is 151!
  //   };
  // },

  // snap = (snapTo: any, value: any) => {
  //   let isArray = _isArray(snapTo), radius: any, is2D: any;
  //
  //   if (!isArray && _isObject(snapTo)) {
  //     radius = isArray = snapTo.radius || _bigNum;
  //
  //     if (snapTo.values) {
  //       snapTo = toArray(snapTo.values);
  //
  //       if ((is2D = !_isNumber(snapTo[0]))) {
  //         radius *= radius; //performance optimization so we don't have to Math.sqrt() in the loop.
  //       }
  //     } else {
  //       snapTo = _roundModifier(snapTo.increment);
  //     }
  //   }
  //
  //   return _conditionalReturn(value, !isArray ? _roundModifier(snapTo) : _isFunction(snapTo) ? (raw: any) => {
  //     is2D = snapTo(raw);
  //
  //     return Math.abs(is2D - raw) <= radius ? is2D : raw;
  //   } : (raw: any) => {
  //     let x = parseFloat(is2D ? raw.x : raw),
  //       y = parseFloat(is2D ? raw.y : 0),
  //       min = _bigNum,
  //       closest = 0,
  //       i = snapTo.length,
  //       dx, dy;
  //
  //     while (i--) {
  //       if (is2D) {
  //         dx = snapTo[i].x - x;
  //         dy = snapTo[i].y - y;
  //         dx = dx * dx + dy * dy;
  //       } else {
  //         dx = Math.abs(snapTo[i] - x);
  //       }
  //
  //       if (dx < min) {
  //         min = dx;
  //         closest = i;
  //       }
  //     }
  //     closest = (!radius || min <= radius) ? snapTo[closest] : raw;
  //
  //     return (is2D || closest === raw || _isNumber(raw)) ? closest : closest + getUnit(raw);
  //   });
  // },

  random = (min: any, max: any, roundingIncrement: any, returnFunction?: any) => _conditionalReturn(_isArray(min) ? !max : roundingIncrement === true ? !!(roundingIncrement = 0) : !returnFunction, () => _isArray(min) ? min[~~(Math.random() * min.length)] : (roundingIncrement = roundingIncrement || 1e-5) && (returnFunction = roundingIncrement < 1 ? 10 ** ((roundingIncrement + '').length - 2) : 1) && (Math.floor(Math.round((min - roundingIncrement / 2 + Math.random() * (max - min + roundingIncrement * .99)) / roundingIncrement) * roundingIncrement * returnFunction) / returnFunction)),
  // pipe = (...functions) => value => functions.reduce((v, f) => f(v), value),
  // unitize = (func, unit) => value => func(parseFloat(value)) + (unit || getUnit(value)),
  // normalize = (min, max, value) => mapRange(min, max, 0, 1, value),
  _wrapArray = (a: any, wrapper: any, value: any) => _conditionalReturn(value, (index: any) => a[~~wrapper(index)]),
  wrap: any = function(min: any, max: any, value: any) { // NOTE: wrap() CANNOT be an arrow function! A very odd compiling bug causes problems (unrelated to GSAP).
    let range = max - min;
    return _isArray(min) ? _wrapArray(min, wrap(0, min.length), max) : _conditionalReturn(value, (value: any) => ((range + (value - min) % range) % range) + min);
  },
  wrapYoyo: any = (min: any, max: any, value: any) => {
    let range = max - min,
      total = range * 2;
    return _isArray(min) ? _wrapArray(min, wrapYoyo(0, min.length - 1), max) : _conditionalReturn(value, (value: any) => {
      value = (total + (value - min) % total) % total || 0;
      return min + ((value > range) ? (total - value) : value);
    });
  },
  _replaceRandom = (value: any) => { //replaces all occurrences of random(...) in a string with the calculated random value. can be a range like random(-100, 100, 5) or an array like random([0, 100, 500])
    let prev = 0,
      s = '',
      i, nums, end, isArray;
    while (~(i = value.indexOf('random(', prev))) {
      end = value.indexOf(')', i);
      isArray = value.charAt(i + 7) === '[';
      nums = value.substring(i + 7, end - i - 7).match(isArray ? _delimitedValueExp : _strictNumExp);
      s += value.substr(prev, i - prev) + random(isArray ? nums : +nums[0], isArray ? 0 : +nums[1], +nums[2] || 1e-5);
      prev = end + 1;
    }
    return s + value.substr(prev, value.length - prev);
  },
  // mapRange = (inMin: any, inMax: any, outMin: any, outMax: any, value: any) => {
  //   let inRange = inMax - inMin,
  //     outRange = outMax - outMin;
  //   return _conditionalReturn(value, (value: any) => outMin + ((((value - inMin) / inRange) * outRange) || 0));
  // },
  interpolate = (start: any, end: any, progress?: any, mutate?: any) => {
    let func = isNaN(start + end) ? 0 : (p: any) => (1 - p) * start + p * end;
    if (!func) {
      let isString = _isString(start),
        master = {},
        p, i, interpolators: any, l: any, il: any;
      progress === true && (mutate = 1) && (progress = null);
      if (isString) {
        start = { p: start };
        end = { p: end };

      } else if (_isArray(start) && !_isArray(end)) {
        interpolators = [];
        l = start.length;
        il = l - 2;
        for (i = 1; i < l; i++) {
          interpolators.push(interpolate(start[i - 1], start[i])); //build the interpolators up front as a performance optimization so that when the function is called many times, it can just reuse them.
        }
        l--;
        func = p => {
          p *= l;
          let i = Math.min(il, ~~p);
          return interpolators[i](p - i);
        };
        progress = end;
      } else if (!mutate) {
        start = _merge(_isArray(start) ? [] : {}, start);
      }
      if (!interpolators) {
        for (p in end) {
          _addPropTween.call(master, start, p, 'get', end[p]);
        }
        func = p => _renderPropTweens(p, master) as any || (isString ? start.p : start);
      }
    }
    return _conditionalReturn(progress, func);
  },
  // _getLabelInDirection = (timeline, fromTime, backward) => { //used for nextLabel() and previousLabel()
  //   let labels = timeline.labels,
  //     min = _bigNum,
  //     p, distance, label;
  //   for (p in labels) {
  //     distance = labels[p] - fromTime;
  //     if ((distance < 0) === !!backward && distance && min > (distance = Math.abs(distance))) {
  //       label = p;
  //       min = distance;
  //     }
  //   }
  //   return label;
  // },
  _callback = (animation: any, type: any, executeLazyFirst?: any) => {
    let v = animation.vars,
      callback = v[type],
      prevContext = _context,
      context = animation._ctx,
      params, scope, result;
    if (!callback) {
      return;
    }
    params = v[type + 'Params'];
    scope = v.callbackScope || animation;
    executeLazyFirst && _lazyTweens.length && _lazyRender(); //in case rendering caused any tweens to lazy-init, we should render them because typically when a timeline finishes, users expect things to have rendered fully. Imagine an onUpdate on a timeline that reports/checks tweened values.
    context && (_context = context);
    result = params ? callback.apply(scope, params) : callback.call(scope);
    _context = prevContext;
    return result;
  },
  // _interrupt = animation => {
  //   _removeFromParent(animation);
  //   animation.scrollTrigger && animation.scrollTrigger.kill(!!_reverting);
  //   animation.progress() < 1 && _callback(animation, 'onInterrupt');
  //   return animation;
  // },
  _quickTween: any,
  // _createPlugin = config => {
  //   config = !config.name && config.default || config; //UMD packaging wraps things oddly, so for example MotionPathHelper becomes {MotionPathHelper:MotionPathHelper, default:MotionPathHelper}.
  //   let name = config.name,
  //     isFunc = _isFunction(config),
  //     Plugin = (name && !isFunc && config.init) ? function() {
  //       this._props = [];
  //     } : config, //in case someone passes in an object that's not a plugin, like CustomEase
  //     instanceDefaults = {
  //       init: _emptyFunc,
  //       render: _renderPropTweens,
  //       add: _addPropTween,
  //       kill: _killPropTweensOf,
  //       modifier: _addPluginModifier,
  //       rawVars: 0,
  //     },
  //     statics = { targetTest: 0, get: 0, getSetter: _getSetter, aliases: {}, register: 0 };
  //   _wake();
  //   if (config !== Plugin) {
  //     if (_plugins[name]) {
  //       return;
  //     }
  //     _setDefaults(Plugin, _setDefaults(_copyExcluding(config, instanceDefaults), statics)); //static methods
  //     _merge(Plugin.prototype, _merge(instanceDefaults, _copyExcluding(config, statics))); //instance methods
  //     _plugins[(Plugin.prop = name)] = Plugin;
  //     if (config.targetTest) {
  //       _harnessPlugins.push(Plugin);
  //       _reservedProps[name] = 1;
  //     }
  //     name = (name === 'css' ? 'CSS' : name.charAt(0).toUpperCase() + name.substr(1)) + 'Plugin'; //for the global name. "motionPath" should become MotionPathPlugin
  //   }
  //   _addGlobal(name, Plugin);
  //   config.register && config.register(gsap, Plugin, PropTween);
  // },

  /*
   * --------------------------------------------------------------------------------------
   * TICKER
   * --------------------------------------------------------------------------------------
   */
  _tickerActive: any,
  _ticker = (function() {
    let _getTime = Date.now,
      _lagThreshold = 500,
      _adjustedLag = 33,
      _startTime = _getTime(),
      _lastUpdate = _startTime,
      _gap = 1000 / 240,
      _nextTime = _gap,
      _listeners: any[] = [],
      _id: any, _req: any, _raf: any, _self: any, _delta: any, _i: any,
      _tick = (v: any) => {
        let elapsed = _getTime() - _lastUpdate,
          manual = v === true,
          overlap, dispatch, time, frame;
        elapsed > _lagThreshold && (_startTime += elapsed - _adjustedLag);
        _lastUpdate += elapsed;
        time = _lastUpdate - _startTime;
        overlap = time - _nextTime;
        if (overlap > 0 || manual) {
          frame = ++_self.frame;
          _delta = time - _self.time * 1000;
          _self.time = time = time / 1000;
          _nextTime += overlap + (overlap >= _gap ? 4 : _gap - overlap);
          dispatch = 1;
        }
        manual || (_id = _req(_tick)); //make sure the request is made before we dispatch the "tick" event so that timing is maintained. Otherwise, if processing the "tick" requires a bunch of time (like 15ms) and we're using a setTimeout() that's based on 16.7ms, it'd technically take 31.7ms between frames otherwise.
        if (dispatch) {
          for (_i = 0; _i < _listeners.length; _i++) { // use _i and check _listeners.length instead of a variable because a listener could get removed during the loop, and if that happens to an element less than the current index, it'd throw things off in the loop.
            _listeners[_i](time, _delta, frame, v);
          }
        }
      };
    _self = {
      time: 0,
      frame: 0,
      // tick() {
      //   _tick(true);
      // },
      // deltaRatio(fps: any) {
      //   return _delta / (1000 / (fps || 60));
      // },
      wake() {
        if (_coreReady) {
          if (!_coreInitted && _windowExists()) {
            _win = _coreInitted = window;
            _doc = _win.document || {};
            _globals.gsap = gsap;
            (_win.gsapVersions || (_win.gsapVersions = [])).push(gsap.version);
            _install(_installScope || _win.GreenSockGlobals || (!_win.gsap && _win) || {});
            _raf = _win.requestAnimationFrame;
          }
          _id && _self.sleep();
          _req = _raf || ((f: any) => setTimeout(f, (_nextTime - _self.time * 1000 + 1) | 0));
          _tickerActive = 1;
          _tick(2);
        }
      },
      sleep() {
        (_raf ? _win.cancelAnimationFrame : clearTimeout)(_id);
        _tickerActive = 0;
        _req = _emptyFunc;
      },
      // lagSmoothing(threshold: any, adjustedLag: any) {
      //   _lagThreshold = threshold || Infinity; // zero should be interpreted as basically unlimited
      //   _adjustedLag = Math.min(adjustedLag || 33, _lagThreshold);
      // },
      // fps(fps: any) {
      //   _gap = 1000 / (fps || 240);
      //   _nextTime = _self.time * 1000 + _gap;
      // },
      add(callback: any, once: any, prioritize: any) {
        let func = once ? (t: any, d: any, f: any, v: any) => {
          callback(t, d, f, v);
          _self.remove(func);
        } : callback;
        _self.remove(callback);
        _listeners[prioritize ? 'unshift' : 'push'](func);
        _wake();
        return func;
      },
      remove(callback: any, i: any) {
        ~(i = _listeners.indexOf(callback)) && _listeners.splice(i, 1) && _i >= i && _i--;
      },
      _listeners: _listeners,
    };
    return _self;
  })(),
  _wake = () => !_tickerActive && _ticker.wake(), //also ensures the core classes are initialized.


  /*
  * -------------------------------------------------
  * EASING
  * -------------------------------------------------
  */
  _easeMap: any = {},
  _customEaseExp = /^[\d.\-M][\d.\-,\s]/,
  _quotesExp = /["']/g,
  _parseObjectInString = (value: any) => { //takes a string like "{wiggles:10, type:anticipate})" and turns it into a real object. Notice it ends in ")" and includes the {} wrappers. This is because we only use this function for parsing ease configs and prioritized optimization rather than reusability.
    let obj: any = {},
      split = value.substr(1, value.length - 3).split(':'),
      key = split[0],
      i = 1,
      l = split.length,
      index, val, parsedVal;
    for (; i < l; i++) {
      val = split[i];
      index = i !== l - 1 ? val.lastIndexOf(',') : val.length;
      parsedVal = val.substr(0, index);
      obj[key] = isNaN(parsedVal) ? parsedVal.replace(_quotesExp, '').trim() : +parsedVal;
      key = val.substr(index + 1).trim();
    }
    return obj;
  },
  _valueInParentheses = (value: any) => {
    let open = value.indexOf('(') + 1,
      close = value.indexOf(')'),
      nested = value.indexOf('(', open);
    return value.substring(open, ~nested && nested < close ? value.indexOf(')', close + 1) : close);
  },
  _configEaseFromString = (name: any) => { //name can be a string like "elastic.out(1,0.5)", and pass in _easeMap as obj and it'll parse it out and call the actual function like _easeMap.Elastic.easeOut.config(1,0.5). It will also parse custom ease strings as long as CustomEase is loaded and registered (internally as _easeMap._CE).
    let split = (name + '').split('('),
      ease = _easeMap[split[0]];
    return (ease && split.length > 1 && ease.config) ? ease.config.apply(null, ~name.indexOf('{') ? [_parseObjectInString(split[1])] : _valueInParentheses(name).split(',').map(_numericIfPossible)) : (_easeMap._CE && _customEaseExp.test(name)) ? _easeMap._CE('', name) : ease;
  },
  _invertEase = (ease: any) => (p: any) => 1 - ease(1 - p),
  // allow yoyoEase to be set in children and have those affected when the parent/ancestor timeline yoyos.
  _propagateYoyoEase = (timeline: any, isYoyo: any) => {
    let child = timeline._first, ease;
    while (child) {
      if (child instanceof Timeline) {
        _propagateYoyoEase(child, isYoyo);
      } else if (child.vars.yoyoEase && (!child._yoyo || !child._repeat) && child._yoyo !== isYoyo) {
        if (child.timeline) {
          _propagateYoyoEase(child.timeline, isYoyo);
        } else {
          ease = child._ease;
          child._ease = child._yEase;
          child._yEase = ease;
          child._yoyo = isYoyo;
        }
      }
      child = child._next;
    }
  },
  _parseEase = (ease: any, defaultEase: any) => !ease ? defaultEase : (_isFunction(ease) ? ease : _easeMap[ease] || _configEaseFromString(ease)) || defaultEase,
  _insertEase = (names: any, easeIn: any, easeOut = (p: any) => 1 - easeIn(1 - p), easeInOut = ((p: any) => p < .5 ? easeIn(p * 2) / 2 : 1 - easeIn((1 - p) * 2) / 2)) => {
    let ease: any = { easeIn, easeOut, easeInOut },
      lowercaseName;
    _forEachName(names, (name: any) => {
      _easeMap[name] = _globals[name] = ease;
      _easeMap[(lowercaseName = name.toLowerCase())] = easeOut;
      for (let p in ease) {
        _easeMap[lowercaseName + (p === 'easeIn' ? '.in' : p === 'easeOut' ? '.out' : '.inOut')] = _easeMap[name + '.' + p] = ease[p];
      }
    });
    return ease;
  },
  _easeInOutFromOut = (easeOut: any) => ((p: any) => p < .5 ? (1 - easeOut(1 - (p * 2))) / 2 : .5 + easeOut((p - .5) * 2) / 2),
  _configElastic = (type?: any, amplitude?: any, period?: any) => {
    let p1 = (amplitude >= 1) ? amplitude : 1, //note: if amplitude is < 1, we simply adjust the period for a more natural feel. Otherwise the math doesn't work right and the curve starts at 1.
      p2 = (period || (type ? .3 : .45)) / (amplitude < 1 ? amplitude : 1),
      p3 = p2 / _2PI * (Math.asin(1 / p1) || 0),
      easeOut = (p: any) => p === 1 ? 1 : p1 * (2 ** (-10 * p)) * _sin((p - p3) * p2) + 1,
      ease: any = (type === 'out') ? easeOut : (type === 'in') ? (p: any) => 1 - easeOut(1 - p) : _easeInOutFromOut(easeOut);
    p2 = _2PI / p2; //precalculate to optimize
    ease.config = (amplitude: any, period: any) => _configElastic(type, amplitude, period);
    return ease;
  },
  _configBack = (type?: any, overshoot = 1.70158) => {
    let easeOut = (p: any) => p ? ((--p) * p * ((overshoot + 1) * p + overshoot) + 1) : 0,
      ease: any = type === 'out' ? easeOut : type === 'in' ? (p: any) => 1 - easeOut(1 - p) : _easeInOutFromOut(easeOut);
    ease.config = (overshoot: any) => _configBack(type, overshoot);
    return ease;
  };

_forEachName('Linear,Quad,Cubic,Quart,Quint,Strong', (name: any, i: any) => {
  let power = i < 5 ? i + 1 : i;
  _insertEase(name + ',Power' + (power - 1), i ? (p: any) => p ** power : (p: any) => p, p => 1 - (1 - p) ** power, p => p < .5 ? (p * 2) ** power / 2 : 1 - ((1 - p) * 2) ** power / 2);
});
_easeMap.Linear.easeNone = _easeMap.none = _easeMap.Linear.easeIn;
_insertEase('Elastic', _configElastic('in'), _configElastic('out'), _configElastic());
((n, c) => {
  let n1 = 1 / c,
    n2 = 2 * n1,
    n3 = 2.5 * n1,
    easeOut = (p: any) => (p < n1) ? n * p * p : (p < n2) ? n * (p - 1.5 / c) ** 2 + .75 : (p < n3) ? n * (p -= 2.25 / c) * p + .9375 : n * (p - 2.625 / c) ** 2 + .984375;
  _insertEase('Bounce', (p: any) => 1 - easeOut(1 - p), easeOut);
})(7.5625, 2.75);
_insertEase('Expo', (p: any) => p ? 2 ** (10 * (p - 1)) : 0);
_insertEase('Circ', (p: any) => -(_sqrt(1 - (p * p)) - 1));
_insertEase('Sine', (p: any) => p === 1 ? 1 : -_cos(p * _HALF_PI) + 1);
_insertEase('Back', _configBack('in'), _configBack('out'), _configBack());
_easeMap.SteppedEase = _easeMap.steps = _globals.SteppedEase = {
  config(steps = 1, immediateStart: any) {
    let p1 = 1 / steps,
      p2 = steps + (immediateStart ? 0 : 1),
      p3 = immediateStart ? 1 : 0,
      max = 1 - _tinyNum;
    return (p: any) => (((p2 * _clamp(0, max, p)) | 0) + p3) * p1;
  },
};
_defaults.ease = _easeMap['quad.out'];

_forEachName('onComplete,onUpdate,onStart,onRepeat,onReverseComplete,onInterrupt', (name: any) => _callbackNames += name + ',' + name + 'Params,');

const { Circ } = _easeMap;

/*
 * --------------------------------------------------------------------------------------
 * CACHE
 * --------------------------------------------------------------------------------------
 */
class GSCache {
  id: number;
  target: any;
  harness: any;
  get: any;

  constructor(target: any, harness: any) {
    this.id = _gsID++;
    target._gsap = this;
    this.target = target;
    this.harness = harness;
    this.get = harness ? harness.get : _getProperty;
    this.get = harness ? harness.getSetter : _getSetter;
  }
}

/*
 * --------------------------------------------------------------------------------------
 * ANIMATION
 * --------------------------------------------------------------------------------------
 */

class Animation {
  vars: any;
  _delay: number;
  _repeat: number;
  _yoyo: boolean = false;
  _ts: number;
  data: any;
  _ctx: any;
  _tDur: any;
  _dirty: number = 0;
  _rDelay: number = 0;
  _rts: number = 1;
  parent: any = null;
  _tTime: number = 0;
  _ps: boolean = false;
  totalTime: any;
  invalidate: any;

  constructor(vars: any) {
    this.vars = vars;
    this._delay = +vars.delay || 0;
    if ((this._repeat = vars.repeat === Infinity ? -2 : vars.repeat || 0)) { // TODO: repeat: Infinity on a timeline's children must flag that timeline internally and affect its totalDuration, otherwise it'll stop in the negative direction when reaching the start.
      this._delay = vars.repeatDelay || 0;
      this._yoyo = !!vars.yoyo || !!vars.yoyoEase;
    }
    this._ts = 1;
    _setDuration(this, +vars.duration, 1, 1);
    this.data = vars.data;
    if (_context) {
      this._ctx = _context;
      _context.data.push(this);
    }
    _tickerActive || _ticker.wake();
  }

  totalDuration(value?: any) {
    if (!arguments.length) {
      return this._tDur;
    }

    this._dirty = 0;

    return _setDuration(this, this._repeat < 0 ? value : (value - (this._repeat * this._rDelay)) / (this._repeat + 1));
  }

  timeScale(value?: any) {
    if (!arguments.length) {
      return this._rts === -_tinyNum ? 0 : this._rts; // recorded timeScale. Special case: if someone calls reverse() on an animation with timeScale of 0, we assign it -_tinyNum to remember it's reversed.
    }
    if (this._rts === value) {
      return this;
    }
    let tTime = this.parent && this._ts ? _parentToChildTotalTime(this.parent._time, this) : this._tTime; // make sure to do the parentToChildTotalTime() BEFORE setting the new _ts because the old one must be used in that calculation.

    // prioritize rendering where the parent's playhead lines up instead of this._tTime because there could be a tween that's animating another tween's timeScale in the same rendering loop (same parent), thus if the timeScale tween renders first, it would alter _start BEFORE _tTime was set on that tick (in the rendering loop), effectively freezing it until the timeScale tween finishes.
    this._rts = +value || 0;
    this._ts = (this._ps || value === -_tinyNum) ? 0 : this._rts; // _ts is the functional timeScale which would be 0 if the animation is paused.
    this.totalTime(_clamp(-this._delay, this._tDur, tTime), true);
    _setEnd(this); // if parent.smoothChildTiming was false, the end time didn't get updated in the _alignPlayhead() method, so do it here.
    return _recacheAncestors(this);
  }
}

_setDefaults(Animation.prototype, {
  _time: 0,
  _start: 0,
  _end: 0,
  _tTime: 0,
  _tDur: 0,
  _dirty: 0,
  _repeat: 0,
  _yoyo: false,
  parent: null,
  _initted: false,
  _rDelay: 0,
  _ts: 1,
  _dp: 0,
  ratio: 0,
  _zTime: -_tinyNum,
  _prom: 0,
  _ps: false,
  _rts: 1,
});


/*
 * -------------------------------------------------
 * TIMELINE
 * -------------------------------------------------
 */

class Timeline extends Animation {
  labels: any;
  smoothChildTiming;
  autoRemoveChildren;
  _sort;
  reverse: any;
  paused: any;
  _time: any;
  _dur: any;
  _zTime: any;
  _initted: any;
  _start: any;
  _lock: any;
  _act: any;
  _hasPause: any;
  _forcing: any;
  _onUpdate: any;
  _first: any;
  _last: any;
  pause: any;
  _prom: any;
  _recent: any;
  _dp: any;
  duration: any;
  reversed: any;

  constructor(vars: any = {}, position?: any) {
    super(vars);
    this.labels = {};
    this.smoothChildTiming = !!vars.smoothChildTiming;
    this.autoRemoveChildren = !!vars.autoRemoveChildren;
    this._sort = _isNotFalse(vars.sortChildren);
    _globalTimeline && _addToTimeline(vars.parent || _globalTimeline, this, position);
    vars.reversed && this.reverse();
    vars.paused && this.paused(true);
    vars.scrollTrigger && _scrollTrigger(this, vars.scrollTrigger);
  }

  // to(targets: any, vars: any, position: any) {
  //   _createTweenType(0, arguments, this);
  //   return this;
  // }

  // from(targets: any, vars: any, position: any) {
  //   _createTweenType(1, arguments, this);
  //   return this;
  // }

  // fromTo(targets, fromVars, toVars, position) {
  //   _createTweenType(2, arguments, this);
  //   return this;
  // }

  set(targets: any, vars: any, position: any) {
    vars.duration = 0;
    vars.parent = this;
    _inheritDefaults(vars).repeatDelay || (vars.repeat = 0);
    vars.immediateRender = !!vars.immediateRender;
    new Tween(targets, vars, _parsePosition(this, position), 1);
    return this;
  }

  call(callback: any, params: any, position: any) {
    return _addToTimeline(this, Tween.delayedCall(0, callback, params), position);
  }

  //ONLY for backward compatibility! Maybe delete?
  // staggerTo(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams) {
  //   vars.duration = duration;
  //   vars.stagger = vars.stagger || stagger;
  //   vars.onComplete = onCompleteAll;
  //   vars.onCompleteParams = onCompleteAllParams;
  //   vars.parent = this;
  //   new Tween(targets, vars, _parsePosition(this, position));
  //   return this;
  // }

  // staggerFrom(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams) {
  //   vars.runBackwards = 1;
  //   _inheritDefaults(vars).immediateRender = _isNotFalse(vars.immediateRender);
  //   return this.staggerTo(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams);
  // }

  // staggerFromTo(targets, duration, fromVars, toVars, stagger, position, onCompleteAll, onCompleteAllParams) {
  //   toVars.startAt = fromVars;
  //   _inheritDefaults(toVars).immediateRender = _isNotFalse(toVars.immediateRender);
  //   return this.staggerTo(targets, duration, toVars, stagger, position, onCompleteAll, onCompleteAllParams);
  // }

  render(totalTime: any, suppressEvents: any, force?: any): any {
    let prevTime = this._time,
      tDur = this._dirty ? this.totalDuration() : this._tDur,
      dur = this._dur,
      tTime = totalTime <= 0 ? 0 : _roundPrecise(totalTime), // if a paused timeline is resumed (or its _start is updated for another reason...which rounds it), that could result in the playhead shifting a **tiny** amount and a zero-duration child at that spot may get rendered at a different ratio, like its totalTime in render() may be 1e-17 instead of 0, for example.
      crossingStart = (this._zTime < 0) !== (totalTime < 0) && (this._initted || !dur),
      time, child, next, iteration, cycleDuration, prevPaused, pauseTween, timeScale, prevStart, prevIteration, yoyo,
      isYoyo;
    this !== _globalTimeline && tTime > tDur && totalTime >= 0 && (tTime = tDur);

    if (tTime !== this._tTime || force || crossingStart) {
      if (prevTime !== this._time && dur) { //if totalDuration() finds a child with a negative startTime and smoothChildTiming is true, things get shifted around internally so we need to adjust the time accordingly. For example, if a tween starts at -30 we must shift EVERYTHING forward 30 seconds and move this timeline's startTime backward by 30 seconds so that things align with the playhead (no jump).
        tTime += this._time - prevTime;
        totalTime += this._time - prevTime;
      }

      time = tTime;
      prevStart = this._start;
      timeScale = this._ts;
      prevPaused = !timeScale;

      if (crossingStart) {
        dur || (prevTime = this._zTime);
        //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration timeline, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect.
        (totalTime || !suppressEvents) && (this._zTime = totalTime);
      }

      if (this._repeat) { //adjust the time for repeats and yoyos
        yoyo = this._yoyo;
        cycleDuration = dur + this._rDelay;

        if (this._repeat < -1 && totalTime < 0) {
          return this.totalTime(cycleDuration * 100 + totalTime, suppressEvents, force);
        }

        time = _roundPrecise(tTime % cycleDuration); //round to avoid floating point errors. (4 % 0.8 should be 0 but some browsers report it as 0.79999999!)

        if (tTime === tDur) { // the tDur === tTime is for edge cases where there's a lengthy decimal on the duration and it may reach the very end but the time is rendered as not-quite-there (remember, tDur is rounded to 4 decimals whereas dur isn't)
          iteration = this._repeat;
          time = dur;
        } else {
          iteration = ~~(tTime / cycleDuration);
          if (iteration && iteration === tTime / cycleDuration) {
            time = dur;
            iteration--;
          }
          time > dur && (time = dur);
        }

        prevIteration = _animationCycle(this._tTime, cycleDuration);
        !prevTime && this._tTime && prevIteration !== iteration && (prevIteration = iteration); // edge case - if someone does addPause() at the very beginning of a repeating timeline, that pause is technically at the same spot as the end which causes this._time to get set to 0 when the totalTime would normally place the playhead at the end.

        if (yoyo && (iteration & 1)) {
          time = dur - time;
          isYoyo = 1;
        }

        /*
        make sure children at the end/beginning of the timeline are rendered properly. If, for example,
        a 3-second long timeline rendered at 2.9 seconds previously, and now renders at 3.2 seconds (which
        would get translated to 2.8 seconds if the timeline yoyos or 0.2 seconds if it just repeats), there
        could be a callback or a short tween that's at 2.95 or 3 seconds in which wouldn't render. So
        we need to push the timeline to the end (and/or beginning depending on its yoyo value). Also we must
        ensure that zero-duration tweens at the very beginning or end of the Timeline work.
        */
        if (iteration !== prevIteration && !this._lock) {
          let rewinding: any = (yoyo && (prevIteration & 1)),
            doesWrap = (rewinding === (yoyo && (iteration & 1)));
          iteration < prevIteration && (rewinding = !rewinding);
          prevTime = rewinding ? 0 : dur;
          this._lock = 1;
          this.render(prevTime || (isYoyo ? 0 : _roundPrecise(iteration * cycleDuration)), suppressEvents, !dur)._lock = 0;
          this._tTime = tTime; // if a user gets the iteration() inside the onRepeat, for example, it should be accurate.
          !suppressEvents && this.parent && _callback(this, 'onRepeat');
          this.vars.repeatRefresh && !isYoyo && (this.invalidate()._lock = 1);

          if ((prevTime && prevTime !== this._time) || prevPaused !== !this._ts || (this.vars.onRepeat && !this.parent && !this._act)) { // if prevTime is 0 and we render at the very end, _time will be the end, thus won't match. So in this edge case, prevTime won't match _time but that's okay. If it gets killed in the onRepeat, eject as well.
            return this;
          }

          dur = this._dur; // in case the duration changed in the onRepeat
          tDur = this._tDur;

          if (doesWrap) {
            this._lock = 2;
            prevTime = rewinding ? dur : -0.0001;
            this.render(prevTime, true);
            this.vars.repeatRefresh && !isYoyo && this.invalidate();
          }

          this._lock = 0;

          if (!this._ts && !prevPaused) {
            return this;
          }

          //in order for yoyoEase to work properly when there's a stagger, we must swap out the ease in each sub-tween.
          _propagateYoyoEase(this, isYoyo);
        }
      }

      if (this._hasPause && !this._forcing && this._lock < 2) {
        pauseTween = _findNextPauseTween(this, _roundPrecise(prevTime), _roundPrecise(time));
        if (pauseTween) {
          tTime -= time - (time = pauseTween._start);
        }
      }

      this._tTime = tTime;
      this._time = time;
      this._act = !timeScale; //as long as it's not paused, force it to be active so that if the user renders independent of the parent timeline, it'll be forced to re-render on the next tick.

      if (!this._initted) {
        this._onUpdate = this.vars.onUpdate;
        this._initted = 1;
        this._zTime = totalTime;
        prevTime = 0; // upon init, the playhead should always go forward; someone could invalidate() a completed timeline and then if they restart(), that would make child tweens render in reverse order which could lock in the wrong starting values if they build on each other, like tl.to(obj, {x: 100}).to(obj, {x: 0}).
      }

      if (!prevTime && time && !suppressEvents) {
        _callback(this, 'onStart');
        if (this._tTime !== tTime) { // in case the onStart triggered a render at a different spot, eject. Like if someone did animation.pause(0.5) or something inside the onStart.
          return this;
        }
      }

      if (time >= prevTime && totalTime >= 0) {
        child = this._first;
        while (child) {
          next = child._next;
          if ((child._act || time >= child._start) && child._ts && pauseTween !== child) {
            if (child.parent !== this) { // an extreme edge case - the child's render could do something like kill() the "next" one in the linked list, or reparent it. In that case we must re-initiate the whole render to be safe.
              return this.render(totalTime, suppressEvents, force);
            }
            child.render(child._ts > 0 ? (time - child._start) * child._ts : (child._dirty ? child.totalDuration() : child._tDur) + (time - child._start) * child._ts, suppressEvents, force);
            if (time !== this._time || (!this._ts && !prevPaused)) { //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
              pauseTween = 0;
              next && (tTime += (this._zTime = -_tinyNum));  // it didn't finish rendering, so flag zTime as negative so that so that the next time render() is called it'll be forced (to render any remaining children)
              break;
            }
          }
          child = next;
        }
      } else {
        child = this._last;
        let adjustedTime = totalTime < 0 ? totalTime : time; //when the playhead goes backward beyond the start of this timeline, we must pass that information down to the child animations so that zero-duration tweens know whether to render their starting or ending values.
        while (child) {
          next = child._prev;
          if ((child._act || adjustedTime <= child._end) && child._ts && pauseTween !== child) {
            if (child.parent !== this) { // an extreme edge case - the child's render could do something like kill() the "next" one in the linked list, or reparent it. In that case we must re-initiate the whole render to be safe.
              return this.render(totalTime, suppressEvents, force);
            }
            child.render(child._ts > 0 ? (adjustedTime - child._start) * child._ts : (child._dirty ? child.totalDuration() : child._tDur) + (adjustedTime - child._start) * child._ts, suppressEvents, force || (_reverting && (child._initted || child._startAt)));  // if reverting, we should always force renders of initted tweens (but remember that .fromTo() or .from() may have a _startAt but not _initted yet). If, for example, a .fromTo() tween with a stagger (which creates an internal timeline) gets reverted BEFORE some of its child tweens render for the first time, it may not properly trigger them to revert.
            if (time !== this._time || (!this._ts && !prevPaused)) { //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
              pauseTween = 0;
              next && (tTime += (this._zTime = adjustedTime ? -_tinyNum : _tinyNum)); // it didn't finish rendering, so adjust zTime so that so that the next time render() is called it'll be forced (to render any remaining children)
              break;
            }
          }
          child = next;
        }
      }

      if (pauseTween && !suppressEvents) {
        this.pause();
        pauseTween.render(time >= prevTime ? 0 : -_tinyNum)._zTime = time >= prevTime ? 1 : -1;
        if (this._ts) { //the callback resumed playback! So since we may have held back the playhead due to where the pause is positioned, go ahead and jump to where it's SUPPOSED to be (if no pause happened).
          this._start = prevStart; //if the pause was at an earlier time and the user resumed in the callback, it could reposition the timeline (changing its startTime), throwing things off slightly, so we make sure the _start doesn't shift.
          _setEnd(this);
          return this.render(totalTime, suppressEvents, force);
        }
      }

      this._onUpdate && !suppressEvents && _callback(this, 'onUpdate', true);

      if ((tTime === tDur && this._tTime >= this.totalDuration()) || (!tTime && prevTime)) if (prevStart === this._start || Math.abs(timeScale) !== Math.abs(this._ts)) if (!this._lock) { // remember, a child's callback may alter this timeline's playhead or timeScale which is why we need to add some of these checks.
        (totalTime || !dur) && ((tTime === tDur && this._ts > 0) || (!tTime && this._ts < 0)) && _removeFromParent(this, 1); // don't remove if the timeline is reversed and the playhead isn't at 0, otherwise tl.progress(1).reverse() won't work. Only remove if the playhead is at the end and timeScale is positive, or if the playhead is at 0 and the timeScale is negative.
        if (!suppressEvents && !(totalTime < 0 && !prevTime) && (tTime || prevTime || !tDur)) {
          _callback(this, (tTime === tDur && totalTime >= 0 ? 'onComplete' : 'onReverseComplete'), true);
          this._prom && !(tTime < tDur && this.timeScale() > 0) && this._prom();
        }
      }
    }

    return this;
  }

  add(child: any, position: any) {
    _isNumber(position) || (position = _parsePosition(this, position, child));
    if (!(child instanceof Animation)) {
      if (_isArray(child)) {
        child.forEach(obj => this.add(obj, position));
        return this;
      }

      if (_isString(child)) {
        return this.addLabel(child, position);
      }

      if (_isFunction(child)) {
        child = Tween.delayedCall(0, child);
      } else {
        return this;
      }
    }

    return this !== child ? _addToTimeline(this, child, position) : this; //don't allow a timeline to be added to itself as a child!
  }

  // getChildren(nested = true, tweens = true, timelines = true, ignoreBeforeTime = -_bigNum) {
  //   let a = [],
  //     child = this._first;
  //   while (child) {
  //     if (child._start >= ignoreBeforeTime) {
  //       if (child instanceof Tween) {
  //         tweens && a.push(child);
  //       } else {
  //         timelines && a.push(child);
  //         nested && a.push(...child.getChildren(true, tweens, timelines));
  //       }
  //     }
  //     child = child._next;
  //   }
  //   return a;
  // }

  // getById(id) {
  //   let animations = this.getChildren(1, 1, 1),
  //     i = animations.length;
  //   while (i--) {
  //     if (animations[i].vars.id === id) {
  //       return animations[i];
  //     }
  //   }
  // }

  remove(child: any) {
    if (_isString(child)) {
      return this.removeLabel(child);
    }

    if (_isFunction(child)) {
      return this.killTweensOf(child);
    }

    _removeLinkedListItem(this, child);
    if (child === this._recent) {
      this._recent = this._last;
    }

    return _uncache(this);
  }

  // @ts-ignore
  totalTime(totalTime: any, suppressEvents: any, force?: any): any {
    if (!arguments.length) {
      return this._tTime;
    }

    this._forcing = force || 1;

    if (!this._dp && this._ts) { //special case for the global timeline (or any other that has no parent or detached parent).
      this._start = _roundPrecise(_ticker.time - (this._ts > 0 ? totalTime / this._ts : (this.totalDuration() - totalTime) / -this._ts));
    }

    super.totalTime(totalTime, suppressEvents);
    this._forcing = force || 0;

    return this;
  }

  addLabel(label: any, position: any) {
    this.labels[label] = _parsePosition(this, position);

    return this;
  }

  removeLabel(label: any) {
    delete this.labels[label];

    return this;
  }

  // addPause(position: any, callback: any, params: any) {
  //   let t = Tween.delayedCall(0, callback || _emptyFunc, params);
  //   t.data = 'isPause';
  //   this._hasPause = 1;
  //   return _addToTimeline(this, t, _parsePosition(this, position));
  // }

  // removePause(position) {
  //   let child = this._first;
  //   position = _parsePosition(this, position);
  //   while (child) {
  //     if (child._start === position && child.data === 'isPause') {
  //       _removeFromParent(child);
  //     }
  //     child = child._next;
  //   }
  // }

  killTweensOf(targets: any, props?: any, onlyActive?: any) {
    let tweens = this.getTweensOf(targets, onlyActive), i = tweens.length;

    while (i--) {
      (_overwritingTween !== tweens[i]) && tweens[i].kill(targets, props);
    }

    return this;
  }

  getTweensOf(targets: any, onlyActive: any) {
    let a = [],
      parsedTargets = toArray(targets),
      child: any = this._first,
      isGlobalTime = _isNumber(onlyActive), // a number is interpreted as a global time. If the animation spans
      children;

    while (child) {
      if (child instanceof Tween) {
        if (_arrayContainsAny(child._targets, parsedTargets) && (isGlobalTime ? (!_overwritingTween || (child._initted && child._ts)) && child.globalTime(0) <= onlyActive && child.globalTime(child.totalDuration()) > onlyActive : !onlyActive || child.isActive())) { // note: if this is for overwriting, it should only be for tweens that aren't paused and are initted.
          a.push(child);
        }
      } else if ((children = child.getTweensOf(parsedTargets, onlyActive)).length) {
        a.push(...children);
      }

      child = child._next;
    }

    return a;
  }

  // tweenTo(position, vars) {
  //   vars = vars || {};
  //   let tl = this,
  //     endTime = _parsePosition(tl, position),
  //     { startAt, onStart, onStartParams, immediateRender } = vars,
  //     initted,
  //     tween = Tween.to(tl, _setDefaults({
  //       ease: vars.ease || 'none',
  //       lazy: false,
  //       immediateRender: false,
  //       time: endTime,
  //       overwrite: 'auto',
  //       duration: vars.duration || (Math.abs((endTime - ((startAt && 'time' in startAt) ? startAt.time : tl._time)) / tl.timeScale())) || _tinyNum,
  //       onStart: () => {
  //         tl.pause();
  //         if (!initted) {
  //           let duration = vars.duration || Math.abs((endTime - ((startAt && 'time' in startAt) ? startAt.time : tl._time)) / tl.timeScale());
  //           (tween._dur !== duration) && _setDuration(tween, duration, 0, 1).render(tween._time, true, true);
  //           initted = 1;
  //         }
  //         onStart && onStart.apply(tween, onStartParams || []); //in case the user had an onStart in the vars - we don't want to overwrite it.
  //       },
  //     }, vars));
  //   return immediateRender ? tween.render(0) : tween;
  // }

  // tweenFromTo(fromPosition, toPosition, vars) {
  //   return this.tweenTo(toPosition, _setDefaults({ startAt: { time: _parsePosition(this, fromPosition) } }, vars));
  // }

  // recent() {
  //   return this._recent;
  // }

  // nextLabel(afterTime = this._time) {
  //   return _getLabelInDirection(this, _parsePosition(this, afterTime));
  // }

  // previousLabel(beforeTime = this._time) {
  //   return _getLabelInDirection(this, _parsePosition(this, beforeTime), 1);
  // }

  // currentLabel(value) {
  //   return arguments.length ? this.seek(value, true) : this.previousLabel(this._time + _tinyNum);
  // }

  shiftChildren(amount: any, adjustLabels: any, ignoreBeforeTime: number = 0) {
    let child = this._first, labels = this.labels, p;

    while (child) {
      if (child._start >= ignoreBeforeTime) {
        child._start += amount;
        child._end += amount;
      }
      child = child._next;
    }

    if (adjustLabels) {
      for (p in labels) {
        if (labels[p] >= ignoreBeforeTime) {
          labels[p] += amount;
        }
      }
    }

    return _uncache(this);
  }

  // @ts-ignore
  invalidate(soft?: any) {
    let child = this._first;
    this._lock = 0;

    while (child) {
      child.invalidate(soft);
      child = child._next;
    }

    return super.invalidate(soft);
  }

  // clear(includeLabels = true) {
  //   let child = this._first,
  //     next;
  //   while (child) {
  //     next = child._next;
  //     this.remove(child);
  //     child = next;
  //   }
  //   this._dp && (this._time = this._tTime = this._pTime = 0);
  //   includeLabels && (this.labels = {});
  //   return _uncache(this);
  // }

  // @ts-ignore
  totalDuration(value?: any) {
    let max = 0,
      self = this,
      child = self._last,
      prevStart = _bigNum,
      prev, start, parent;

    if (arguments.length) {
      return self.timeScale((self._repeat < 0 ? self.duration() : self.totalDuration()) / (self.reversed() ? -value : value));
    }

    if (self._dirty) {
      parent = self.parent;

      while (child) {
        prev = child._prev; //record it here in case the tween changes position in the sequence...
        child._dirty && child.totalDuration(); //could change the tween._startTime, so make sure the animation's cache is clean before analyzing it.
        start = child._start;

        if (start > prevStart && self._sort && child._ts && !self._lock) { //in case one of the tweens shifted out of order, it needs to be re-inserted into the correct position in the sequence
          self._lock = 1; //prevent endless recursive calls - there are methods that get triggered that check duration/totalDuration when we add().
          _addToTimeline(self, child, start - child._delay, 1)._lock = 0;
        } else {
          prevStart = start;
        }

        if (start < 0 && child._ts) { //children aren't allowed to have negative startTimes unless smoothChildTiming is true, so adjust here if one is found.
          max -= start;

          if ((!parent && !self._dp) || (parent && parent.smoothChildTiming)) {
            self._start += start / self._ts;
            self._time -= start;
            self._tTime -= start;
          }

          self.shiftChildren(-start, false, -1e999);
          prevStart = 0;
        }

        child._end > max && child._ts && (max = child._end);
        child = prev;
      }

      _setDuration(self, (self === _globalTimeline && self._time > max) ? self._time : max, 1, 1);
      self._dirty = 0;
    }

    return self._tDur;
  }

  static updateRoot(time: any) {
    if (_globalTimeline._ts) {
      _lazySafeRender(_globalTimeline, _parentToChildTotalTime(time, _globalTimeline));
      _lastRenderedFrame = _ticker.frame;
    }
    if (_ticker.frame >= _nextGCFrame) {
      _nextGCFrame += _config.autoSleep || 120;
      let child = _globalTimeline._first;
      if (!child || !child._ts) if (_config.autoSleep && _ticker._listeners.length < 2) {
        while (child && !child._ts) {
          child = child._next;
        }
        child || _ticker.sleep();
      }
    }
  }
}

//note: we call _addComplexStringPropTween.call(tweenInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
let _addComplexStringPropTween = function(target: any, prop: any, start: any, end: any, setter: any, stringFilter: any, funcParam: any) {
    // @ts-ignore
    let pt: any = new PropTween(this._pt as any, target, prop, 0, 1, _renderComplexString, null, setter),
      index = 0,
      matchIndex = 0,
      result, startNums, color, endNum, chunk, startNum, hasRandom, a;
    pt.b = start;
    pt.e = end;
    start += ''; //ensure values are strings
    end += '';

    if ((hasRandom = ~end.indexOf('random('))) {
      end = _replaceRandom(end);
    }

    if (stringFilter) {
      a = [start, end];
      stringFilter(a, target, prop); //pass an array with the starting and ending values and let the filter do whatever it needs to the values.
      start = a[0];
      end = a[1];
    }

    startNums = start.match(_complexStringNumExp) || [];

    while ((result = _complexStringNumExp.exec(end))) {
      endNum = result[0];
      chunk = end.substring(index, result.index);

      if (color) {
        color = (color + 1) % 5;
      } else if (chunk.substr(-5) === 'rgba(') {
        color = 1;
      }

      if (endNum !== startNums[matchIndex++]) {
        startNum = parseFloat(startNums[matchIndex - 1]) || 0;
        //these nested PropTweens are handled in a special way - we'll never actually call a render or setter method on them. We'll just loop through them in the parent complex string PropTween's render method.
        pt._pt = {
          _next: pt._pt,
          p: (chunk || matchIndex === 1) ? chunk : ',', //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
          s: startNum,
          c: endNum.charAt(1) === '=' ? _parseRelative(startNum, endNum) - startNum : parseFloat(endNum) - startNum,
          m: (color && color < 4) ? Math.round : 0,
        };
        index = _complexStringNumExp.lastIndex;
      }
    }

    pt.c = (index < end.length) ? end.substring(index, end.length) : ''; //we use the "c" of the PropTween to store the final part of the string (after the last number)
    pt.fp = funcParam;

    if (_relExp.test(end) || hasRandom) {
      pt.e = 0; //if the end string contains relative values or dynamic random(...) values, delete the end it so that on the final render we don't actually set it to the string with += or -= characters (forces it to use the calculated value).
    }

    // @ts-ignore
    this._pt = pt; //start the linked list with this new PropTween. Remember, we call _addComplexStringPropTween.call(tweenInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.

    return pt;
  },
  _addPropTween = function(target: any, prop: any, start: any, end: any, index?: any, targets?: any, modifier?: any, stringFilter?: any, funcParam?: any, optional?: any) {
    _isFunction(end) && (end = end(index || 0, target, targets));
    let currentValue = target[prop],
      parsedStart = (start !== 'get') ? start : !_isFunction(currentValue) ? currentValue : (funcParam ? target[(prop.indexOf('set') || !_isFunction(target['get' + prop.substr(3)])) ? prop : 'get' + prop.substr(3)](funcParam) : target[prop]()),
      setter = !_isFunction(currentValue) ? _setterPlain : funcParam ? _setterFuncWithParam : _setterFunc,
      pt: any;

    if (_isString(end)) {
      if (~end.indexOf('random(')) {
        end = _replaceRandom(end);
      }

      if (end.charAt(1) === '=') {
        pt = _parseRelative(parsedStart, end) + (getUnit(parsedStart) || 0);

        if (pt || pt === 0) { // to avoid isNaN, like if someone passes in a value like "!= whatever"
          end = pt;
        }
      }
    }

    if (!optional || parsedStart !== end || _forceAllPropTweens) {
      if (!isNaN(parsedStart * end) && end !== '') { // fun fact: any number multiplied by "" is evaluated as the number 0!
        // @ts-ignore
        pt = new PropTween(this._pt, target, prop, +parsedStart || 0, end - (parsedStart || 0), typeof (currentValue) === 'boolean' ? _renderBoolean : _renderPlain, 0, setter);
        funcParam && (pt.fp = funcParam);
        // @ts-ignore
        modifier && pt.modifier(modifier, this, target);

        // @ts-ignore
        return (this._pt = pt);
      }

      !currentValue && !(prop in target) && _missingPlugin(prop, end);

      // @ts-ignore
      return _addComplexStringPropTween.call(this, target, prop, parsedStart, end, setter, stringFilter || _config.stringFilter, funcParam);
    }
  },
  //creates a copy of the vars object and processes any function-based values (putting the resulting values directly into the copy) as well as strings with "random()" in them. It does NOT process relative values.
  _processVars = (vars: any, index: any, target: any, targets: any, tween: any) => {
    _isFunction(vars) && (vars = _parseFuncOrString(vars, tween, index, target, targets));

    if (!_isObject(vars) || (vars.style && vars.nodeType) || _isArray(vars) || _isTypedArray(vars)) {
      return _isString(vars) ? _parseFuncOrString(vars, tween, index, target, targets) : vars;
    }

    let copy: any = {}, p;

    for (p in vars) {
      copy[p] = _parseFuncOrString(vars[p], tween, index, target, targets);
    }

    return copy;
  },
  _checkPlugin = (property: any, vars: any, tween: any, index: any, target: any, targets: any) => {
    let plugin, pt, ptLookup, i;

    if (_plugins[property] && (plugin = new _plugins[property]()).init(target, plugin.rawVars ? vars[property] : _processVars(vars[property], index, target, targets, tween), tween, index, targets) !== false) {
      tween._pt = pt = new PropTween(tween._pt, target, property, 0, 1, plugin.render, plugin, 0, plugin.priority);

      if (tween !== _quickTween) {
        ptLookup = tween._ptLookup[tween._targets.indexOf(target)]; //note: we can't use tween._ptLookup[index] because for staggered tweens, the index from the fullTargets array won't match what it is in each individual tween that spawns from the stagger.
        i = plugin._props.length;

        while (i--) {
          ptLookup[plugin._props[i]] = pt;
        }
      }
    }

    return plugin;
  },
  _overwritingTween: any, //store a reference temporarily so we can avoid overwriting itself.
  _forceAllPropTweens: any,
  _initTween = (tween: any, time: any, tTime: any) => {
    let vars = tween.vars,
      {
        ease,
        startAt,
        immediateRender,
        lazy,
        onUpdate,
        onUpdateParams,
        callbackScope,
        runBackwards,
        yoyoEase,
        keyframes,
        autoRevert,
      } = vars,
      dur = tween._dur,
      prevStartAt = tween._startAt,
      targets = tween._targets,
      parent = tween.parent,
      //when a stagger (or function-based duration/delay) is on a Tween instance, we create a nested timeline which means that the "targets" of that tween don't reflect the parent. This function allows us to discern when it's a nested tween and in that case, return the full targets array so that function-based values get calculated properly. Also remember that if the tween has a stagger AND keyframes, it could be multiple levels deep which is why we store the targets Array in the vars of the timeline.
      fullTargets = (parent && parent.data === 'nested') ? parent.vars.targets : targets,
      autoOverwrite = (tween._overwrite === 'auto') && !_suppressOverwrites,
      tl = tween.timeline,
      cleanVars, i, p, pt: any, target, hasPriority, gsData, harness, plugin, ptLookup: any, index, harnessVars,
      overwritten;
    tl && (!keyframes || !ease) && (ease = 'none');
    tween._ease = _parseEase(ease, _defaults.ease);
    tween._yEase = yoyoEase ? _invertEase(_parseEase(yoyoEase === true ? ease : yoyoEase, _defaults.ease)) : 0;

    if (yoyoEase && tween._yoyo && !tween._repeat) { //there must have been a parent timeline with yoyo:true that is currently in its yoyo phase, so flip the eases.
      yoyoEase = tween._yEase;
      tween._yEase = tween._ease;
      tween._ease = yoyoEase;
    }

    tween._from = !tl && !!vars.runBackwards; //nested timelines should never run backwards - the backwards-ness is in the child tweens.

    if (!tl || (keyframes && !vars.stagger)) { //if there's an internal timeline, skip all the parsing because we passed that task down the chain.
      harness = targets[0] ? _getCache(targets[0]).harness : 0;
      harnessVars = harness && vars[harness.prop]; //someone may need to specify CSS-specific values AND non-CSS values, like if the element has an "x" property plus it's a standard DOM element. We allow people to distinguish by wrapping plugin-specific stuff in a css:{} object for example.
      cleanVars = _copyExcluding(vars, _reservedProps);

      if (prevStartAt) {
        prevStartAt._zTime < 0 && prevStartAt.progress(1); // in case it's a lazy startAt that hasn't rendered yet.
        (time < 0 && runBackwards && immediateRender && !autoRevert) ? prevStartAt.render(-1, true) : prevStartAt.revert(runBackwards && dur ? _revertConfigNoKill : _startAtRevertConfig); // if it's a "startAt" (not "from()" or runBackwards: true), we only need to do a shallow revert (keep transforms cached in CSSPlugin)
        // don't just _removeFromParent(prevStartAt.render(-1, true)) because that'll leave inline styles. We're creating a new _startAt for "startAt" tweens that re-capture things to ensure that if the pre-tween values changed since the tween was created, they're recorded.
        prevStartAt._lazy = 0;
      }

      if (startAt) {
        _removeFromParent(tween._startAt = Tween.set(targets, _setDefaults({
          data: 'isStart',
          overwrite: false,
          parent: parent,
          immediateRender: true,
          lazy: !prevStartAt && _isNotFalse(lazy),
          startAt: null,
          delay: 0,
          onUpdate: onUpdate,
          onUpdateParams: onUpdateParams,
          callbackScope: callbackScope,
          stagger: 0,
        }, startAt))); //copy the properties/values into a new object to avoid collisions, like var to = {x:0}, from = {x:500}; timeline.fromTo(e, from, to).fromTo(e, to, from);
        tween._startAt._dp = 0; // don't allow it to get put back into root timeline! Like when revert() is called and totalTime() gets set.
        tween._startAt._sat = tween; // used in globalTime(). _sat stands for _startAtTween
        (time < 0 && (_reverting || (!immediateRender && !autoRevert))) && tween._startAt.revert(_revertConfigNoKill); // rare edge case, like if a render is forced in the negative direction of a non-initted tween.

        if (immediateRender) {
          if (dur && time <= 0 && tTime <= 0) { // check tTime here because in the case of a yoyo tween whose playhead gets pushed to the end like tween.progress(1), we should allow it through so that the onComplete gets fired properly.
            time && (tween._zTime = time);
            return; //we skip initialization here so that overwriting doesn't occur until the tween actually begins. Otherwise, if you create several immediateRender:true tweens of the same target/properties to drop into a Timeline, the last one created would overwrite the first ones because they didn't get placed into the timeline yet before the first render occurs and kicks in overwriting.
          }
        }
      } else if (runBackwards && dur) {
        //from() tweens must be handled uniquely: their beginning values must be rendered but we don't want overwriting to occur yet (when time is still 0). Wait until the tween actually begins before doing all the routines like overwriting. At that time, we should render at the END of the tween to ensure that things initialize correctly (remember, from() tweens go backwards)
        if (!prevStartAt) {
          time && (immediateRender = false); //in rare cases (like if a from() tween runs and then is invalidate()-ed), immediateRender could be true but the initial forced-render gets skipped, so there's no need to force the render in this context when the _time is greater than 0
          p = _setDefaults({
            overwrite: false,
            data: 'isFromStart', //we tag the tween with as "isFromStart" so that if [inside a plugin] we need to only do something at the very END of a tween, we have a way of identifying this tween as merely the one that's setting the beginning values for a "from()" tween. For example, clearProps in CSSPlugin should only get applied at the very END of a tween and without this tag, from(...{height:100, clearProps:"height", delay:1}) would wipe the height at the beginning of the tween and after 1 second, it'd kick back in.
            lazy: immediateRender && !prevStartAt && _isNotFalse(lazy),
            immediateRender: immediateRender, //zero-duration tweens render immediately by default, but if we're not specifically instructed to render this tween immediately, we should skip this and merely _init() to record the starting values (rendering them immediately would push them to completion which is wasteful in that case - we'd have to render(-1) immediately after)
            stagger: 0,
            parent: parent, //ensures that nested tweens that had a stagger are handled properly, like gsap.from(".class", {y:gsap.utils.wrap([-100,100])})
          }, cleanVars);
          harnessVars && (p[harness.prop] = harnessVars); // in case someone does something like .from(..., {css:{}})
          _removeFromParent(tween._startAt = Tween.set(targets, p));
          tween._startAt._dp = 0; // don't allow it to get put back into root timeline!
          tween._startAt._sat = tween; // used in globalTime()
          (time < 0) && (_reverting ? tween._startAt.revert(_revertConfigNoKill) : tween._startAt.render(-1, true));
          tween._zTime = time;

          if (!immediateRender) {
            _initTween(tween._startAt, _tinyNum, _tinyNum); //ensures that the initial values are recorded
          } else if (!time) {
            return;
          }
        }
      }
      tween._pt = tween._ptCache = 0;
      lazy = (dur && _isNotFalse(lazy)) || (lazy && !dur);

      for (i = 0; i < targets.length; i++) {
        target = targets[i];
        gsData = target._gsap || _harness(targets)[i]._gsap;
        tween._ptLookup[i] = ptLookup = {};
        _lazyLookup[gsData.id] && _lazyTweens.length && _lazyRender(); //if other tweens of the same target have recently initted but haven't rendered yet, we've got to force the render so that the starting values are correct (imagine populating a timeline with a bunch of sequential tweens and then jumping to the end)
        index = fullTargets === targets ? i : fullTargets.indexOf(target);

        if (harness && (plugin = new harness()).init(target, harnessVars || cleanVars, tween, index, fullTargets) !== false) {
          tween._pt = pt = new PropTween(tween._pt, target, plugin.name, 0, 1, plugin.render, plugin, 0, plugin.priority);
          plugin._props.forEach((name: any) => {
            ptLookup[name] = pt;
          });
          plugin.priority && (hasPriority = 1);
        }

        if (!harness || harnessVars) {
          for (p in cleanVars) {
            if (_plugins[p] && (plugin = _checkPlugin(p, cleanVars, tween, index, target, fullTargets))) {
              plugin.priority && (hasPriority = 1);
            } else {
              ptLookup[p] = pt = _addPropTween.call(tween, target, p, 'get', cleanVars[p], index, fullTargets, 0, vars.stringFilter);
            }
          }
        }

        tween._op && tween._op[i] && tween.kill(target, tween._op[i]);

        if (autoOverwrite && tween._pt) {
          _overwritingTween = tween;
          _globalTimeline.killTweensOf(target, ptLookup, tween.globalTime(time)); // make sure the overwriting doesn't overwrite THIS tween!!!
          overwritten = !tween.parent;
          _overwritingTween = 0;
        }

        tween._pt && lazy && (_lazyLookup[gsData.id] = 1);
      }

      hasPriority && _sortPropTweensByPriority(tween);
      tween._onInit && tween._onInit(tween); //plugins like RoundProps must wait until ALL of the PropTweens are instantiated. In the plugin's init() function, it sets the _onInit on the tween instance. May not be pretty/intuitive, but it's fast and keeps file size down.
    }
    tween._onUpdate = onUpdate;
    tween._initted = (!tween._op || tween._pt) && !overwritten; // if overwrittenProps resulted in the entire tween being killed, do NOT flag it as initted or else it may render for one tick.
    (keyframes && time <= 0) && tl.render(_bigNum, true, true); // if there's a 0% keyframe, it'll render in the "before" state for any staggered/delayed animations thus when the following tween initializes, it'll use the "before" state instead of the "after" state as the initial values.
  },
  // _updatePropTweens = (tween, property, value, start, startIsRelative, ratio, time) => {
  //   let ptCache = ((tween._pt && tween._ptCache) || (tween._ptCache = {}))[property],
  //     pt, rootPT, lookup, i;
  //   if (!ptCache) {
  //     ptCache = tween._ptCache[property] = [];
  //     lookup = tween._ptLookup;
  //     i = tween._targets.length;
  //     while (i--) {
  //       pt = lookup[i][property];
  //       if (pt && pt.d && pt.d._pt) { // it's a plugin, so find the nested PropTween
  //         pt = pt.d._pt;
  //         while (pt && pt.p !== property && pt.fp !== property) { // "fp" is functionParam for things like setting CSS variables which require .setProperty("--var-name", value)
  //           pt = pt._next;
  //         }
  //       }
  //       if (!pt) { // there is no PropTween associated with that property, so we must FORCE one to be created and ditch out of this
  //         // if the tween has other properties that already rendered at new positions, we'd normally have to rewind to put them back like tween.render(0, true) before forcing an _initTween(), but that can create another edge case like tweening a timeline's progress would trigger onUpdates to fire which could move other things around. It's better to just inform users that .resetTo() should ONLY be used for tweens that already have that property. For example, you can't gsap.to(...{ y: 0 }) and then tween.restTo("x", 200) for example.
  //         _forceAllPropTweens = 1; // otherwise, when we _addPropTween() and it finds no change between the start and end values, it skips creating a PropTween (for efficiency...why tween when there's no difference?) but in this case we NEED that PropTween created so we can edit it.
  //         tween.vars[property] = '+=0';
  //         _initTween(tween, time);
  //         _forceAllPropTweens = 0;
  //         return 1;
  //       }
  //       ptCache.push(pt);
  //     }
  //   }
  //   i = ptCache.length;
  //   while (i--) {
  //     rootPT = ptCache[i];
  //     pt = rootPT._pt || rootPT; // complex values may have nested PropTweens. We only accommodate the FIRST value.
  //     pt.s = (start || start === 0) && !startIsRelative ? start : pt.s + (start || 0) + ratio * pt.c;
  //     pt.c = value - pt.s;
  //     rootPT.e && (rootPT.e = _round(value) + getUnit(rootPT.e)); // mainly for CSSPlugin (end value)
  //     rootPT.b && (rootPT.b = pt.s + getUnit(rootPT.b));          // (beginning value)
  //   }
  // },
  // _addAliasesToVars = (targets, vars) => {
  //   let harness = targets[0] ? _getCache(targets[0]).harness : 0,
  //     propertyAliases = (harness && harness.aliases),
  //     copy, p, i, aliases;
  //   if (!propertyAliases) {
  //     return vars;
  //   }
  //   copy = _merge({}, vars);
  //   for (p in propertyAliases) {
  //     if (p in copy) {
  //       aliases = propertyAliases[p].split(',');
  //       i = aliases.length;
  //       while (i--) {
  //         copy[aliases[i]] = copy[p];
  //       }
  //     }
  //
  //   }
  //   return copy;
  // },
  // parses multiple formats, like {"0%": {x: 100}, {"50%": {x: -20}} and { x: {"0%": 100, "50%": -20} }, and an "ease" can be set on any object. We populate an "allProps" object with an Array for each property, like {x: [{}, {}], y:[{}, {}]} with data for each property tween. The objects have a "t" (time), "v", (value), and "e" (ease) property. This allows us to piece together a timeline later.
  // _parseKeyframe = (prop, obj, allProps, easeEach) => {
  //   let ease = obj.ease || easeEach || 'power1.inOut',
  //     p, a;
  //   if (_isArray(obj)) {
  //     a = allProps[prop] || (allProps[prop] = []);
  //     // t = time (out of 100), v = value, e = ease
  //     obj.forEach((value, i) => a.push({ t: i / (obj.length - 1) * 100, v: value, e: ease }));
  //   } else {
  //     for (p in obj) {
  //       a = allProps[p] || (allProps[p] = []);
  //       p === 'ease' || a.push({ t: parseFloat(prop), v: obj[p], e: ease });
  //     }
  //   }
  // },
  _parseFuncOrString = (value: any, tween: any, i: any, target: any, targets: any) => (_isFunction(value) ? value.call(tween, i, target, targets) : (_isString(value) && ~value.indexOf('random(')) ? _replaceRandom(value) : value),
  _staggerTweenProps = _callbackNames + 'repeat,repeatDelay,yoyo,repeatRefresh,yoyoEase,autoRevert',
  _staggerPropsToSkip: any = {};
_forEachName(_staggerTweenProps + ',id,stagger,delay,duration,paused,scrollTrigger', (name: any) => _staggerPropsToSkip[name] = 1);

/*
 * --------------------------------------------------------------------------------------
 * TWEEN
 * --------------------------------------------------------------------------------------
 */

class Tween extends Animation {
  static delayedCall: any;
  _targets: any;
  _initted: any;
  globalTime: any;
  isActive: any;
  static set: any;
  _ptLookup: any;
  _time: any;
  _dur: any;
  timeline: any;
  _startAt: any;
  _zTime: any;
  _yEase: any;
  _lock: any;
  _act: any;
  _lazy: any;
  ratio: any;
  _ease: any;
  _from: any;
  _pt: any;
  _onUpdate: any;
  _prom: any;

  constructor(targets: any[], vars: any, position: any, skipInherit?: any) {
    if (typeof (vars) === 'number') {
      position.duration = vars;
      vars = position;
      position = null;
    }
    super(skipInherit ? vars : _inheritDefaults(vars));
    let parent = vars.parent || _globalTimeline,
      parsedTargets = (_isArray(targets) || _isTypedArray(targets) ? _isNumber(targets[0]) : ('length' in vars)) ? [targets] : toArray(targets); // edge case: someone might try animating the "length" of an object with a "length" property that's initially set to 0 so don't interpret that as an empty Array-like object.
    this._targets = parsedTargets.length ? _harness(parsedTargets) : [];
    this._ptLookup = []; //PropTween lookup. An array containing an object for each target, having keys for each tweening property

    _addToTimeline(parent, this, position);
  }

  render(totalTime: any, suppressEvents: any, force?: any): any {
    let prevTime = this._time,
      tDur = this._tDur,
      dur = this._dur,
      isNegative = totalTime < 0,
      tTime = (totalTime > tDur - _tinyNum && !isNegative) ? tDur : (totalTime < _tinyNum) ? 0 : totalTime,
      time, pt, iteration, cycleDuration, prevIteration, isYoyo, ratio, timeline, yoyoEase;

    if (!dur) {
      _renderZeroDurationTween(this, totalTime, suppressEvents, force);
    } else if (tTime !== this._tTime || !totalTime || force || (!this._initted && this._tTime) || (this._startAt && (this._zTime < 0) !== isNegative)) { //this senses if we're crossing over the start time, in which case we must record _zTime and force the render, but we do it in this lengthy conditional way for performance reasons (usually we can skip the calculations): this._initted && (this._zTime < 0) !== (totalTime < 0)
      time = tTime;
      timeline = this.timeline;

      if (this._repeat) { //adjust the time for repeats and yoyos
        cycleDuration = dur + this._rDelay;

        if (this._repeat < -1 && isNegative) {
          return this.totalTime(cycleDuration * 100 + totalTime, suppressEvents, force);
        }

        time = _roundPrecise(tTime % cycleDuration); //round to avoid floating point errors. (4 % 0.8 should be 0 but some browsers report it as 0.79999999!)

        if (tTime === tDur) { // the tDur === tTime is for edge cases where there's a lengthy decimal on the duration and it may reach the very end but the time is rendered as not-quite-there (remember, tDur is rounded to 4 decimals whereas dur isn't)
          iteration = this._repeat;
          time = dur;
        } else {
          iteration = ~~(tTime / cycleDuration);
          if (iteration && iteration === tTime / cycleDuration) {
            time = dur;
            iteration--;
          }
          time > dur && (time = dur);
        }

        isYoyo = this._yoyo && (iteration & 1);

        if (isYoyo) {
          yoyoEase = this._yEase;
          time = dur - time;
        }

        prevIteration = _animationCycle(this._tTime, cycleDuration);

        if (time === prevTime && !force && this._initted) {
          //could be during the repeatDelay part. No need to render and fire callbacks.
          this._tTime = tTime;
          return this;
        }

        if (iteration !== prevIteration) {
          timeline && this._yEase && _propagateYoyoEase(timeline, isYoyo);

          //repeatRefresh functionality
          if (this.vars.repeatRefresh && !isYoyo && !this._lock) {
            this._lock = force = 1; //force, otherwise if lazy is true, the _attemptInitTween() will return and we'll jump out and get caught bouncing on each tick.
            this.render(_roundPrecise(cycleDuration * iteration), true).invalidate()._lock = 0;
          }
        }
      }

      if (!this._initted) {
        if (_attemptInitTween(this, isNegative ? totalTime : time, force, suppressEvents, tTime)) {
          this._tTime = 0; // in constructor if immediateRender is true, we set _tTime to -_tinyNum to have the playhead cross the starting point but we can't leave _tTime as a negative number.

          return this;
        }

        if (prevTime !== this._time) { // rare edge case - during initialization, an onUpdate in the _startAt (.fromTo()) might force this tween to render at a different spot in which case we should ditch this render() call so that it doesn't revert the values.
          return this;
        }

        if (dur !== this._dur) { // while initting, a plugin like InertiaPlugin might alter the duration, so rerun from the start to ensure everything renders as it should.
          return this.render(totalTime, suppressEvents, force);
        }
      }

      this._tTime = tTime;
      this._time = time;

      if (!this._act && this._ts) {
        this._act = 1; //as long as it's not paused, force it to be active so that if the user renders independent of the parent timeline, it'll be forced to re-render on the next tick.
        this._lazy = 0;
      }

      this.ratio = ratio = (yoyoEase || this._ease)(time / dur);

      if (this._from) {
        this.ratio = ratio = 1 - ratio;
      }

      if (time && !prevTime && !suppressEvents) {
        _callback(this, 'onStart');

        if (this._tTime !== tTime) { // in case the onStart triggered a render at a different spot, eject. Like if someone did animation.pause(0.5) or something inside the onStart.
          return this;
        }
      }

      pt = this._pt;

      while (pt) {
        pt.r(ratio, pt.d);
        pt = pt._next;
      }

      (timeline && timeline.render(totalTime < 0 ? totalTime : !time && isYoyo ? -_tinyNum : timeline._dur * timeline._ease(time / this._dur), suppressEvents, force)) || (this._startAt && (this._zTime = totalTime));

      if (this._onUpdate && !suppressEvents) {
        isNegative && _rewindStartAt(this, totalTime, force); //note: for performance reasons, we tuck this conditional logic inside less traveled areas (most tweens don't have an onUpdate). We'd just have it at the end before the onComplete, but the values should be updated before any onUpdate is called, so we ALSO put it here and then if it's not called, we do so later near the onComplete.
        _callback(this, 'onUpdate');
      }

      this._repeat && iteration !== prevIteration && this.vars.onRepeat && !suppressEvents && this.parent && _callback(this, 'onRepeat');

      if ((tTime === this._tDur || !tTime) && this._tTime === tTime) {
        isNegative && !this._onUpdate && _rewindStartAt(this, totalTime, true);
        (totalTime || !dur) && ((tTime === this._tDur && this._ts > 0) || (!tTime && this._ts < 0)) && _removeFromParent(this, 1); // don't remove if we're rendering at exactly a time of 0, as there could be autoRevert values that should get set on the next tick (if the playhead goes backward beyond the startTime, negative totalTime). Don't remove if the timeline is reversed and the playhead isn't at 0, otherwise tl.progress(1).reverse() won't work. Only remove if the playhead is at the end and timeScale is positive, or if the playhead is at 0 and the timeScale is negative.
        if (!suppressEvents && !(isNegative && !prevTime) && (tTime || prevTime || isYoyo)) { // if prevTime and tTime are zero, we shouldn't fire the onReverseComplete. This could happen if you gsap.to(... {paused:true}).play();
          _callback(this, (tTime === tDur ? 'onComplete' : 'onReverseComplete'), true);
          this._prom && !(tTime < tDur && this.timeScale() > 0) && this._prom();
        }
      }

    }

    return this;
  }

  static to(targets: any, vars: any, position: any) {
    return new Tween(targets, vars, position);
  }
}

/*
 * --------------------------------------------------------------------------------------
 * PROPTWEEN
 * --------------------------------------------------------------------------------------
 */
let _setterPlain = (target: any, property: any, value: any) => target[property] = value,
  _setterFunc = (target: any, property: any, value: any) => target[property](value),
  _setterFuncWithParam = (target: any, property: any, value: any, data: any) => target[property](data.fp, value),
  _setterAttribute = (target: any, property: any, value: any) => target.setAttribute(property, value),
  _getSetter = (target: any, property: any) => _isFunction(target[property]) ? _setterFunc : _isUndefined(target[property]) && target.setAttribute ? _setterAttribute : _setterPlain,
  _renderPlain = (ratio: any, data: any) => data.set(data.t, data.p, Math.round((data.s + data.c * ratio) * 1000000) / 1000000, data),
  _renderBoolean = (ratio: any, data: any) => data.set(data.t, data.p, !!(data.s + data.c * ratio), data),
  _renderComplexString = function(ratio: any, data: any) {
    let pt = data._pt,
      s = '';
    if (!ratio && data.b) { //b = beginning string
      s = data.b;
    } else if (ratio === 1 && data.e) { //e = ending string
      s = data.e;
    } else {
      while (pt) {
        s = pt.p + (pt.m ? pt.m(pt.s + pt.c * ratio) : (Math.round((pt.s + pt.c * ratio) * 10000) / 10000)) + s; //we use the "p" property for the text inbetween (like a suffix). And in the context of a complex string, the modifier (m) is typically just Math.round(), like for RGB colors.
        pt = pt._next;
      }
      s += data.c; //we use the "c" of the PropTween to store the final chunk of non-numeric text.
    }
    data.set(data.t, data.p, s, data);
  },
  _renderPropTweens = function(ratio: any, data: any) {
    let pt = data._pt;
    while (pt) {
      pt.r(ratio, pt.d);
      pt = pt._next;
    }
  },
  // _addPluginModifier = function(modifier, tween, target, property) {
  //   let pt = this._pt,
  //     next;
  //   while (pt) {
  //     next = pt._next;
  //     pt.p === property && pt.modifier(modifier, tween, target);
  //     pt = next;
  //   }
  // },
  // _killPropTweensOf = function(property) {
  //   let pt = this._pt,
  //     hasNonDependentRemaining, next;
  //   while (pt) {
  //     next = pt._next;
  //     if ((pt.p === property && !pt.op) || pt.op === property) {
  //       _removeLinkedListItem(this, pt, '_pt');
  //     } else if (!pt.dep) {
  //       hasNonDependentRemaining = 1;
  //     }
  //     pt = next;
  //   }
  //   return !hasNonDependentRemaining;
  // },
  _setterWithModifier = (target: any, property: any, value: any, data: any) => {
    data.mSet(target, property, data.m.call(data.tween, value, data.mt), data);
  },
  _sortPropTweensByPriority = (parent: any) => {
    let pt = parent._pt,
      next, pt2, first, last;
    //sorts the PropTween linked list in order of priority because some plugins need to do their work after ALL of the PropTweens were created (like RoundPropsPlugin and ModifiersPlugin)
    while (pt) {
      next = pt._next;
      pt2 = first;
      while (pt2 && pt2.pr > pt.pr) {
        pt2 = pt2._next;
      }
      if ((pt._prev = pt2 ? pt2._prev : last)) {
        pt._prev._next = pt;
      } else {
        first = pt;
      }
      if ((pt._next = pt2)) {
        pt2._prev = pt;
      } else {
        last = pt;
      }
      pt = next;
    }
    parent._pt = first;
  };

//PropTween key: t = target, p = prop, r = renderer, d = data, s = start, c = change, op = overwriteProperty (ONLY populated when it's different than p), pr = priority, _next/_prev for the linked list siblings, set = setter, m = modifier, mSet = modifierSetter (the original setter, before a modifier was added)
class PropTween {
  t: any;
  s: any;
  c: any;
  p: any;
  r: any;
  d: any;
  set: any;
  pr: any;
  _next: any;
  mSet: any;
  m: any;
  mt: any;
  tween: any;

  constructor(next: any, target: any, prop: any, start: any, change: any, renderer: any, data: any, setter: any, priority?: any) {
    this.t = target;
    this.s = start;
    this.c = change;
    this.p = prop;
    this.r = renderer || _renderPlain;
    this.d = data || this;
    this.set = setter || _setterPlain;
    this.pr = priority || 0;
    this._next = next;
    if (next) {
      next._prev = this;
    }
  }

  modifier(func: any, tween: any, target: any): void {
    this.mSet = this.mSet || this.set; //in case it was already set (a PropTween can only have one modifier)
    this.set = _setterWithModifier;
    this.m = func;
    this.mt = target; //modifier target
    this.tween = tween;
  }
}


//Initialization tasks
_forEachName(_callbackNames + 'parent,duration,ease,delay,overwrite,runBackwards,startAt,yoyo,immediateRender,repeat,repeatDelay,data,paused,reversed,lazy,callbackScope,stringFilter,id,yoyoEase,stagger,inherit,repeatRefresh,keyframes,autoRevert,scrollTrigger', (name: any) => _reservedProps[name] = 1);
_globals.TweenMax = _globals.TweenLite = Tween;
_globals.TimelineLite = _globals.TimelineMax = Timeline;
_globalTimeline = new Timeline({
  sortChildren: false,
  defaults: _defaults,
  autoRemoveChildren: true,
  id: 'root',
  smoothChildTiming: true,
});


/*
 * --------------------------------------------------------------------------------------
 * GSAP
 * --------------------------------------------------------------------------------------
 */
const gsap: any = {
  install: _install,
  effects: _effects,
  ticker: _ticker,
  updateRoot: Timeline.updateRoot,
  plugins: _plugins,
  globalTimeline: _globalTimeline,
  core: {
    PropTween,
    globals: _addGlobal,
    Tween,
    Timeline,
    Animation,
    getCache: _getCache,
    _removeLinkedListItem,
    // reverting: () => _reverting,
    // context: (toAdd: any) => {
    //   if (toAdd && _context) {
    //     _context.data.push(toAdd);
    //     toAdd._ctx = _context;
    //   }
    //   return _context;
    // },
  },
};

// @ts-ignore
_forEachName('to,from,fromTo,delayedCall,set,killTweensOf', (name: any) => gsap[name] = Tween[name]);
_ticker.add(Timeline.updateRoot);
_quickTween = gsap.to({}, { duration: 0 });

_coreReady = 1;
_windowExists() && _wake();
